<template>
  <el-container class="container" style="padding:0">
    <!-- 侧边栏 -->
    <el-aside width="300px" style="background: #F6F8FB;height:100%">
      <!-- 侧边栏顶部tab组-->
      <div class="sel-head">
        <div class="my-btn">
          <div :class="btSelect==='pre'?'my-btn-item my-btn-select':'my-btn-item'" @click="tabSelectInterceptor('pre')">
            预设
          </div>
          <div :class="btSelect === 'custom'||btSelect === 'addanother'?'my-btn-item my-btn-select':'my-btn-item'"
               @click="tabSelectInterceptor('custom')">自定义
          </div>
          <div :class="btSelect==='often'?'my-btn-item my-btn-select':'my-btn-item'"
               @click="tabSelectInterceptor('often')">常用
          </div>
        </div>
      </div>
      <!-- 侧边栏中部列表-->
      <div class="sel-content">
        <!--订单列表-预设-->
        <div class="box-card" v-if="btSelect === 'pre'" shadow="never"
             :body-style="{ backgroundColor: '#F6F8FB', padding: '0' }">
          <ul class="items">
            <li :class="itemSelectID === item.itemId ? 'li-active' : ''" @click="leftAsideItemClick(item,idx)"
                v-for="(item,idx) in selectPre">
              <div class="text" v-if="op==='updateName'&&itemSelectID === item.itemId">
                <el-input v-model="anotherName" ref='inputs' placeholder="请输入该搜索名称" maxlength="11" show-word-limit
                          autofocus @keyup.enter.native='addAnother' @click.stop @blur="inputBlur"></el-input>
              </div>
              <div class="text" v-else>
                {{ item.name }}
              </div>
              <div class="text" v-if="op==='create'&&itemSelectID === item.itemId">
                <el-input v-model="anotherName" ref='inputs' placeholder="请输入新的搜索名称" maxlength="11" show-word-limit
                          autofocus @keyup.enter.native='addAnother' @click.stop @blur="inputBlur"></el-input>
              </div>
              <el-popover
                  placement="bottom"
                  v-model:visible="dialogShow"
                  :width="deleteShow?180:110"
                  popper-class="popitem"
                  trigger="click"
                  @hide="deleteShow=false"
                  v-if="itemSelectID === item.itemId&&op!=='updateName'&&op!='create'"
              >
                <template #reference>
                  <img src="../assets/img/btn.png" alt="" class="btn">
                </template>
                <div class="btn-list">
                  <template v-if="!deleteShow">
                    <div class="btn-item" @click.prevent="opendialog('另存为')">另存为</div>
                  </template>
                  <template v-else>
                    <div
                        style="width:180px;height:80px;font-size: 14px;font-family: Helvetica;color: #5A5E66; text-align:center">
                      <p>是否需要删除此搜索</p>
                      <div style="margin:0 20px;display:flex;justify-content:space-between">
                        <el-button type="primary" size="mini"
                                   style="background: #FFFFFF;border-radius: 100px;font-family: Helvetica;color: #5A5E66;border: 1px solid #DCDFE6;"
                                   @click="deleteShow = false;op = ''">取消
                        </el-button>
                        <el-button type="primary" size="mini"
                                   style="background: #FE5858;border-radius: 100px;font-family: Helvetica;color: #FFFFFF;border: 1px solid #DCDFE6;"
                                   @click="deleteSelect">确定
                        </el-button>
                      </div>
                    </div>
                  </template>
                </div>
              </el-popover>
            </li>
          </ul>
        </div>
        <!-- 侧边栏列表-自定义 -->
        <div class="box-card" v-else-if="btSelect === 'custom'||btSelect === 'addanother'" shadow="never"
             :body-style="{ backgroundColor: '#F6F8FB', padding: '0' }">
          <ul class="items">
            <li :class="itemSelectID === item.itemId ? 'li-active' : ''" @click="leftAsideItemClick(item,idx)"
                v-for="(item,idx) in selectCustom">
              <div class="text" v-if="op==='updateName'&&itemSelectID === item.itemId">
                <el-input v-model="anotherName" ref='inputs' placeholder="请输入该搜索名称" maxlength="11" show-word-limit
                          autofocus @keyup.enter.native='addAnother' @click.stop @blur="inputBlur"></el-input>
              </div>
              <div class="text" v-else>
                <img src="../assets/img/dotactive.png" class="dot" v-if="item.changed&&itemSelectID === item.itemId"/>
                <img src="../assets/img/dot.png" class="dot" v-if="item.changed&&itemSelectID !== item.itemId"/>
                {{ item.name }}
              </div>
              <div class="text" v-if="op==='create'&&itemSelectID === item.itemId">
                <el-input v-model="anotherName" ref='inputs' placeholder="请输入新的搜索名称" maxlength="11" show-word-limit
                          autofocus @keyup.enter.native='addAnother' @click.stop @blur="inputBlur"></el-input>
              </div>
              <el-popover
                  placement="bottom"
                  v-model:visible="dialogShow"
                  :width="deleteShow?180:110"
                  popper-class="popitem"
                  trigger="click"
                  @hide="deleteShow=false"
                  v-if="itemSelectID === item.itemId&&op!=='updateName'&&op!='create'"
              >
                <template #reference>
                  <img src="../assets/img/btn.png" alt="" class="btn">
                </template>
                <div class="btn-list">
                  <template v-if="!deleteShow">
                    <div class="btn-item" @click.prevent="opendialog('修改名称')">修改名称</div>
                    <div class="btn-item" @click.prevent="opendialog('另存为')">另存为</div>
                    <div class="btn-item delete-item " @click="deleteShow=true">删除本搜索</div>
                  </template>
                  <template v-else>
                    <div
                        style="width:180px;height:80px;font-size: 14px;font-family: Helvetica;color: #5A5E66; text-align:center">
                      <p>是否需要删除此搜索</p>
                      <div style="margin:0 20px;display:flex;justify-content:space-between">
                        <el-button type="primary" size="mini"
                                   style="background: #FFFFFF;border-radius: 100px;font-family: Helvetica;color: #5A5E66;border: 1px solid #DCDFE6;"
                                   @click="deleteShow = false">取消
                        </el-button>
                        <el-button type="primary" size="mini"
                                   style="background: #FE5858;border-radius: 100px;font-family: Helvetica;color: #FFFFFF;border: 1px solid #DCDFE6;"
                                   @click="deleteSelect">确定
                        </el-button>
                      </div>
                    </div>
                  </template>
                </div>
              </el-popover>
            </li>
          </ul>
        </div>
        <!-- 侧边栏列表-常用tab-->
        <div class="box-card" v-else-if="btSelect === 'often'" shadow="never"
             :body-style="{ backgroundColor: '#F6F8FB', padding: '0' }">
          <ul class="items">
            <li :class="itemSelectID === item.itemId ? 'item li-active' : 'item'" @click="leftAsideItemClick(item,idx)"
                v-for="(item,idx) in selectOften">
              <div class="text" v-if="op==='updateName'&&itemSelectID === item.itemId">
                <el-input v-model="anotherName" ref='inputs' placeholder="请输入该搜索名称" maxlength="11" show-word-limit
                          autofocus @keyup.enter.native='addAnother' @click.stop @blur="inputBlur"></el-input>
              </div>
              <div class="text" v-else>
                <img src="../assets/img/dotactive.png" class="dot"
                     v-if="item.changed&&itemSelectID === item.itemId&&item.type!=='pre'"/>
                <img src="../assets/img/dot.png" class="dot"
                     v-if="item.changed&&itemSelectID !== item.itemId&&item.type!=='pre'"/>
                {{ item.name }}
              </div>
              <div class="text" v-if="op==='create'&&itemSelectID === item.itemId">
                <el-input v-model="anotherName" ref="inputs" placeholder="请输入新的搜索名称" maxlength="11" show-word-limit
                          autofocus @keyup.enter.native='addAnother' @click.stop @blur="inputBlur"></el-input>
              </div>
              <el-popover
                  placement="bottom"
                  :width="deleteShow?180:110"
                  popper-class="popitem"
                  trigger="click"
                  @hide="deleteShow=false"
                  v-if="itemSelectID === item.itemId&&op!=='updateName'&&op!='create'"
                  id="saveAsPopover"
              >
                <template #reference>
                  <img src="../assets/img/btn.png" alt="" class="btn">
                </template>
                <!-- 常用选项中（不是预设的下拉弹框）-->
                <div class="btn-list" v-if="item.type!=='pre'">
                  <template v-if="!deleteShow">
                    <div class="btn-item" @click.prevent="opendialog('修改名称')">修改名称</div>
                    <div class="btn-item" @click.prevent="opendialog('另存为')">另存为</div>
                    <div class="btn-item delete-item " @click="deleteShow=true">删除本搜索</div>
                  </template>
                  <template v-else>
                    <div
                        style="width:180px;height:80px;font-size: 14px;font-family: Helvetica;color: #5A5E66; text-align:center">
                      <p>是否需要删除此搜索</p>
                      <div style="margin:0 20px;display:flex;justify-content:space-between">
                        <el-button type="primary" size="mini"
                                   style="background: #FFFFFF;border-radius: 100px;font-family: Helvetica;color: #5A5E66;border: 1px solid #DCDFE6;"
                                   @click="deleteShow = false">取消
                        </el-button>
                        <el-button type="primary" size="mini"
                                   style="background: #FE5858;border-radius: 100px;font-family: Helvetica;color: #FFFFFF;border: 1px solid #DCDFE6;"
                                   @click="deleteSelect">确定
                        </el-button>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 常用选项中（预设的下拉弹框）-->
                <div class="btn-list" v-else>
                  <div class="btn-item" @click="opendialog('另存为')">另存为</div>
                </div>
              </el-popover>
            </li>
          </ul>
        </div>
      </div>
      <!-- 侧边栏底部保存按钮-->
      <div class="box-bottom" v-if="itemSelectType !== 'pre'">
        <el-button type="primary" class="addSelect" :disabled="!itemSelectChanged" @click="saveSelect">
          <i class="el-icon-document-checked saveIcon"></i>
          保存搜索条件
        </el-button>
      </div>
    </el-aside>
    <!-- 主要内容容器 -->
    <el-container style="position:relative;height:100%">
      <!-- 容器顶部筛选条件按钮 -->
      <el-header style="overflow:unset;height: 134px">
        <div style="display: flex;flex-direction: column;width: calc(100% - 40px);padding:0 20px;">
          <!-- 容器顶部左侧汇总按钮组 -->
          <el-tabs v-if="tabShow" class="summaryTabs" style="margin-top: 10px;" v-model="seletcTab" @tab-click="summaryAction(seletcTab*1)"
                   :before-leave="beforeLeave">
            <el-tab-pane v-for="item in navigateTabs" :key="'tab'+item.id" :label="item.label"
                         :name="item.id"></el-tab-pane>
          </el-tabs>
          <!--          v-show="!isSummary||!summaryLoading"-->
          <!-- 新版入口：C位引导用户进入新版 -->
          <a class="new-version-link" href="/dao">
            <span class="new-version-link__badge">NEW</span>
            <span class="new-version-link__text">进入新版</span>
            <i class="el-icon-arrow-right new-version-link__arrow"></i>
          </a>
          <div style="display: flex;justify-content: space-between;width: 100%;align-items: center">
            <!-- 汇总纬度选择框 -->
            <div v-if="isSummary" style="display: flex;align-items: center">
              <div style="font-size: 14px;color: #606266;line-height: 14px;font-weight: 400;margin-right: 8px;">分类字段：
              </div>
              <custom-cascader :accu-dimension="accu_dimension"
                               @accu-dimension-update="accuDimensionUpdate"
                               :colums="column_summary_array"
                               :loading="summaryLoading"
              ></custom-cascader>
              <div
                  style="font-size: 14px;color: #606266;line-height: 14px;font-weight: 400;margin-left:32px;margin-right: 8px;">
                时间段：
              </div>
              <!--              <el-date-picker-->
              <!--                  ref="myDateSelector"-->
              <!--                  style="width: 250px"-->
              <!--                  v-model="accu_start_end_date"-->
              <!--                  type="daterange"-->
              <!--                  unlink-panels-->
              <!--                  :editable="false"-->
              <!--                  range-separator="至"-->
              <!--                  start-placeholder="2018-01-01"-->
              <!--                  end-placeholder="至今"-->
              <!--                  format="yyyy-MM-dd"-->
              <!--                  value-format="yyyy-MM-dd"-->
              <!--                  :picker-options="pickerOptions"-->
              <!--                  :clearable="false"-->
              <!--                  :disabled="summaryLoading"-->
              <!--              >-->
              <!--              </el-date-picker>-->
              <div @click="openStartPicker">
                <el-input
                    style="width: 150px"
                    placeholder="2018-01-01"
                    prefix-icon="el-icon-date"
                    readonly
                    :value="accu_start_end_date_dynamic[0].value"
                    :disabled="summaryLoading"
                >
                </el-input>
              </div>
              <!-- 真正的date-picker隐藏在后面-->
              <el-date-picker
                  class="date_style"
                  ref="startDatePicker"
                  style="width: 150px"
                  v-model="accu_start_end_date[0]"
                  align="center"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="2018-01-01"
                  :picker-options="pickerOptionsStart"
                  :disabled="summaryLoading"
              >
              </el-date-picker>

              <div style="padding: 0 8px;font-size: 14px;opacity: .6;">至</div>

              <div @click="openEndPicker">
                <el-input
                    style="width: 150px"
                    placeholder="今天"
                    prefix-icon="el-icon-date"
                    readonly
                    :value="accu_start_end_date_dynamic[1].value"
                    :disabled="summaryLoading"
                >
                </el-input>
              </div>
              <!-- 真正的date-picker隐藏在后面-->
              <el-date-picker
                  class="date_style"
                  ref="endDatePicker"
                  style="width: 150px"
                  v-model="accu_start_end_date[1]"
                  align="center"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="至今"
                  :picker-options="pickerOptionsEnd"
                  :disabled="summaryLoading">
              </el-date-picker>
            </div>
            <div style="position:relative" class="deep"></div>
            <!-- 容器顶部右侧筛选按钮组 -->
            <div style="display:flex;justify-content:space-between;" :style="isSummary?'width:160px':'width:200px;'">
              <!-- 页面行数按钮 -->
              <div v-show="!isSummary" class="imgbox">
                <el-popover
                    placement="bottom"
                    :width="300"
                    trigger="click"
                >
                  <template #reference>
                    <div class="coloums"></div>
                  </template>
                  <div class="coloums-list coloums-width">
                    <div class="coloums-title ">页面行数</div>
                    <div class="items" style="height:180px">
                      <div v-for='(item,index) in tableRows' :key="index"
                           :class="item===pagesize?'item selected':'item'"
                           @click="setPagesize(item)">{{ item }}
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <!-- 筛选列按钮 -->
              <div class="imgbox">
                <el-popover
                    ref="selectColumPop"
                    placement="bottom"
                    :width="360"
                    trigger="click"
                >
                  <template #reference>
                    <div class="coloumSelect"></div>
                  </template>
                  <div class="coloums-list" v-loading="isSummary&&JSON.stringify(column_mapper_accu_filter)==='{}'">
                    <div class="coloums-title">筛选列</div>
                    <el-input v-show="isSummary==0"
                              style="width:calc(100% - 40px);margin-left: 20px;margin-bottom: 16px;"
                              v-model="selectColumnNameInput" placeholder="输入列的名称" @input="coloumNameChange"
                              clearable></el-input>
                    <div v-show="isSummary==0" class="items">
                      <div v-for="(item,key,index) in select_column_mapper_show" :key="index" class="item-coloums"
                           @click="coloumsChange(key)">
                        <img src="../assets/img/coloums_show.png" alt="" v-if="showColoums.indexOf(key)!=-1">
                        <img src="../assets/img/coloums_not.png" alt="" v-else>
                        <span :style="showColoums.indexOf(key)!=-1?'color:#429FFF':''">
                          <!-- 金额:已打款金额(元):decimal  ==取出==>  金额:已打款金额(元) -->
                          {{ item.slice(0, item.lastIndexOf(":")) }}
                        </span>
                      </div>
                    </div>
                    <div v-show="isSummary==1" class="items" style="height: 340px">
                      <div v-for="(item,key,index) in column_mapper_accu_filter" :key="index" class="item-coloums"
                           @click="coloumsChangeAccu(key)">
                        <img src="../assets/img/coloums_show.png" alt="" v-if="showColoumsAccuTemp.indexOf(key)!=-1">
                        <img src="../assets/img/coloums_not.png" alt="" v-else>
                        <span :style="showColoumsAccuTemp.indexOf(key)!=-1?'color:#429FFF':''">
                      <!-- 金额:已打款金额(元):decimal  ==取出==>  金额:已打款金额(元) -->
                      {{ item.slice(0, item.lastIndexOf(":")) }}
                    </span>
                      </div>
                    </div>
                    <div v-show="isSummary==1" style="justify-content: space-between;padding: 20px;display:flex;">
                      <el-button type="danger" style="flex:1" @click="summaryColumnSelectCancel">取消</el-button>
                      <el-button type="primary" style="flex: 1" @click="summaryColumnSelectComfirm">确认</el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
              <!-- 筛选条件按钮 -->
              <div class="imgbox">
                <el-popover
                    @hide="filterHiden"
                    placement="bottom"
                    :width="360"
                    trigger="click">
                  <template #reference>
                    <div class="select"></div>
                  </template>
                  <div class="coloums-list">
                    <div class="coloums-title">筛选条件</div>
                    <div class="items-select">
                      <el-input @focus="openColoumName" v-model="columnNameInput" placeholder="选择列"
                                @input="coloumNameChange" clearable
                                @clear="selectColoumName='';"></el-input>
                      <div class="myoption" v-show="coloumNameShow">
                        <ul v-if="column_mapper_show">
                          <li @click.stop="getColoumName(key)"
                              v-for="(item,key,index) in column_mapper_show" :key="index">
                            {{ item.slice(0, item.lastIndexOf(":")) }}
                          </li>
                        </ul>
                      </div>


                    </div>
                    <div class="items-select">
                      <div class="myselect" @click="openFilter">
                        <span v-show=" JSON.stringify(filter)==='{}'">选择过滤器</span>
                        <span v-show=" JSON.stringify(filter)!=='{}'"
                              style="color:rgba(96, 98, 102, 1);">{{ filter.label }}</span>
                        <img src="../assets/img/Shape.png" alt="">
                      </div>
                      <div class="myoption" v-show="filterShow">
                        <ul v-if="selectoption&&selectoption[0]">
                          <template v-if="selectType==='number'">
                            <li class="hoverCls" @click="getFilter(item)" v-for="(item,index) in selectoption[0]"
                                :key="index">{{
                                item.label
                              }}
                            </li>
                          </template>
                          <template v-else-if="selectType==='string'">
                            <li @click="getFilter(item)" v-for="(item,index) in selectoption[1]" :key="index">{{
                                item.label
                              }}
                            </li>
                          </template>
                          <template v-else-if="selectType==='date'">
                            <li @click="getFilter(item)" v-for="(item,index) in selectoption[2]" :key="index">{{
                                item.label
                              }}
                            </li>
                          </template>
                        </ul>
                      </div>
                    </div>
                    <div class="items-select">
                      <el-input v-model="columnValue"
                                :placeholder="selectType==='date'?'请输入日期(格式为yyyy-MM-dd)':'请输入内容'"></el-input>
                    </div>
                    <div class="btn-select">
                      <el-button type="danger" @click="emptySelect"
                                 style="width:138px;background: #FF4242;font-size: 16px;font-family: SourceHanSansSC-Regular, SourceHanSansSC;font-weight: 400;color: #FFFFFF;">
                        清空所有
                      </el-button>
                      <el-button type="primary" @click="submitSelect"
                                 style="font-size: 16px;background: #429FFF;font-family: SourceHanSansSC-Regular, SourceHanSansSC;font-weight: 400;color: #FFFFFF;">
                        添加筛选条件
                      </el-button>
                    </div>
                    <div class="result_title" v-show="queryCond.length>0">
                      <div class="title">筛选过滤展示</div>
                      <div class="result">过滤结果：{{ totalnums }}条</div>
                    </div>
                    <div v-show="queryCond.length>0" style="padding-bottom:32px">
                      <div class="select_list" v-for="item in queryCond">
                    <span
                        class="text">{{
                        column_mapper[item.columnName] ? column_mapper[item.columnName].slice(0, column_mapper[item.columnName].lastIndexOf(':')) : ""
                      }} {{ filter_mapper[item.filter] }} {{ item.columnValue }}</span>
                        <img class="hoverCls" src="../assets/img/delete_select.png" alt="" @click="removeSelect(item)">
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <!-- 导出按钮 -->
              <div class="imgbox">
                <div class="export" @click="exportExcel"></div>
              </div>
              <!-- 刷新按钮 -->
              <div class="imgbox">
                <div class="refresh" @click="refresh"></div>
              </div>
            </div>
          </div>


        </div>
        <div v-show="false">
          <el-skeleton :loading="summaryLoading" style="width: calc(100% - 40px);margin-left: 20px" animated>
            <template #template>
              <div>
                <div style="display: flex;align-items: center;justify-content: space-between;height: 60px;width: 100%;">
                  <el-skeleton-item variant="rect" style="width: 350px;height: 60px"/>
                  <el-skeleton-item variant="rect" style="width: 320px;margin-left: 30px;height: 60px"/>
                  <el-skeleton-item variant="rect" style="width: 240px;margin-left: auto;margin-right: 0;height: 60px"/>
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>

      </el-header>


      <!-- 列表表格 -->
      <div v-show="!isSummary" style="padding-bottom: 20px;">
        <!--
        //列表相关
        @row-click 点击列表某个item事件
        project-list-dl 表格列表内容

        //列和表头相关
        @column-drop 表头拖动排序事件
        show-coloums-dl 显示的列（即表头显示的）
        column_mapper 所有的列枚举（包含未在表头显示的）

        //排序相关
        @sort-change 排序变化事件
        sort-column-name-dl 排序的名称
        sort-column-order-dl 排序的规则

        //页面控制相关
        @current-change  当前页改变事件
        totalnums-dl 总页数
        pagesize-dl 每页页数
        page-number-dl 当前页

        //表头固定
        fixed-columns
        -->
        <custom-table
            ref="mytable"
            :table-id="0"
            @row-click="rowClick"
            :project-list-dl="projectList"

            @column-drop="columnDropUpdate"
            :show-coloums-dl="showColoums"
            :column_mapper="column_mapper"

            @sort-change="sortChange"
            :sort-column-name-dl="sortColumnName"
            :sort-column-order-dl="sortColumnOrder"

            @current-change="currentChange"
            :totalnums-dl="totalnums"
            :pagesize-dl="pagesize"
            :page-number-dl="pageNumber"

            :fixed-columns="fixedList"

            :sortable="true"

            :pagination="true"

            :is-loading-dl="detailLoading"
            :use-virtual="false"
            :row-hegit="0"

            :tableColumnCustomConfig="tableColumnCustomConfig"
            @unusualShow="unusualShow"
        ></custom-table>
      </div>
      <!-- 汇总表格 -->
      <div v-show="isSummary" style="padding-bottom: 20px;height:100%;">
        <custom-table
            ref="mytable2"
            :table-id="1"
            @row-click="rowClickAccu"
            :project-list-dl="projectListAccu"

            @column-drop="columnDropUpdateAccu"
            :show-coloums-dl="showColoumsAccu"
            :column_mapper="column_mapper_accu"

            @current-change="currentChange"
            :totalnums-dl="totalnumsAccu"
            :pagesize-dl="totalnumsAccu"
            :page-number-dl="pageNumberAccu"

            :fixed-columns="fixedListAccu"

            :sortable="false"

            :pagination="false"

            :is-loading-dl="summaryLoading"

            :use-virtual="true"
            :row-hegit="68"
        ></custom-table>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import selectoption from "./assets/selectoption.json"
// import {this.$message} from 'element-plus'
import VueCookies from 'vue-cookies'
// import {this.$loading} from 'element-plus';
import customCascader from './CustomCascader.vue'
import CustomTable from './CustomTable.vue'
import {
  getProjects,
  changeSelection,
  getSelection,
  exportExcel,
  updateLasttime,
  updateName,
  getAccu,
  exportExcelAccu,
  getUnusualList
} from '../api/api.js';
import {
  getWeekStartDate,
  getWeekEndDate,
  getLastWeekStartDate,
  getLastWeekEndDate,
  getMonthStartDate,
  getMonthEndDate,
  getLastMonthStartDate,
  getLastMonthEndDate,
  getQuarterStartDate,
  getQuarterEndDate,
  getLastQuarterStartDate, getLastYearStartDate, getYearStartDate,getLastYearEndDate,getLastQuarterEndDate,getYearEndDate
} from "@/utils/util";

const userid = VueCookies.get("userid")

/**
 * 侧边栏搜索条件按 last_time 排序
 * 历史数据里 last_time 可能为空或格式异常，直接调用 replace 会抛错，
 * 而该计算属性在默认的“常用”tab 渲染时就会执行，一旦抛错会导致整个
 * ProjectList 渲染中断（表格和侧栏搜索条件一起消失）。
 */
function selectionTimeValue(lastTime) {
  if (!lastTime) return 0
  const time = new Date(String(lastTime).replace(/-/g, '/')).getTime()
  return isNaN(time) ? 0 : time
}

/**
 * 搜索条件的 content 是后端存储的 JSON 字符串，解析失败时返回空对象，
 * 避免脏数据导致列表初始化中断。
 */
function parseSelectionContent(content) {
  if (!content) return {}
  if (typeof content === 'object') return content
  try {
    return JSON.parse(content) || {}
  } catch (e) {
    console.warn('搜索条件内容解析失败', content, e)
    return {}
  }
}

export default {
  name: "orders",
  props:["refreshId"],
  components: {
    customCascader,
    CustomTable
  },
  data() {
    return {
      //屏幕宽度获取
      timer: false,
      screenWidth: document.body.clientWidth,

      //侧边顶部tab
      btSelect: "often", //顶部的筛选（预设 自定义 常用）

      //侧边栏item更多操作
      dialogShow: false,//左侧item的更多操作弹窗
      deleteShow: false,//更多操作-删除选项-显示删除弹窗
      anotherName: "",//另存为的名字

      //侧边栏数据
      leftSideSelects: [],//侧边栏列表
      leftSideSelectsOld: [],//侧边栏列表旧数据

      //左侧选中的item相关
      itemName: '',
      itemSelectID: 0, //小的筛选
      itemSelectChanged: false,//筛选条件是否改变，如果改变，则底部"保存搜索条件"按钮禁用
      itemSelectType: "",//当前选中的侧边栏的item类型，如果不是pre预设类型，则显示底部"保存搜索条件"按钮


      op: '',//接口的操作指令


      //表格列表相关
      detailLoading: false,
      projectList: [],//表格列表数据
      column_mapper: {},//表头所有列的枚举
      showColoums: [],//当前显示的表头列//["project:project_id","project:project_name","client:client_name","project:quotation_type","amount:quotation","amount:income","amount:collection","status:project_stage","status:project_status","time:first_quotation_time","term_amount:this_week_income","term_amount:last_week_income"]
      sortColumnName: "",//需要排序的列名
      sortColumnOrder: "",//排序的命令
      totalnums: 0,//所有的数据条数
      pageNumber: 1,//当前页
      fixedList: ['project:project_id', 'project:project_name'],
      tableColumnCustomConfig:{//图表某些列定制化显示
        'project:project_id':{
          type:"popover",
          showRule:{
            key:"project:project_remark",
            value:"异常"
          },
          project_id:"",
          closeTime:1,
          openTime:0,
          forceClose:false,
          show:false,
          popoverDatas:[]
        }
      },

      pagesize: 10,//一页数据的行数（公用）
      tableRows: [10, 20, 30, 50, 100],//配置页面的行数选择（公用的）

      //汇总列表
      projectListAccu: [],//汇总数据列表
      column_mapper_accu: {},//汇总表头所有列的枚举
      showColoumsAccu: [],//汇总所有展示列信息
      showColoumsAccuTemp: [],//汇总所有展示列信息,副本，只有点击确认按钮时才映射到showColoumsAccu上
      sortColumnNameAccu: "",//汇总列表需要排序的列名
      sortColumnOrderAccu: "",//汇总列表排序的命令
      totalnumsAccu: 0,//汇总列表所有的数据条数
      pageNumberAccu: 1,//汇总列表当前页
      fixedListAccu: [],


      //筛选条件相关
      //筛选条件-第一步-选择列
      columnNameInput: '',//1、input输入框内容
      coloumNameShow: false,//2、点击input后开关下拉弹窗
      coloumName: "",//3、选中下拉框的一个列后，获得列的key，如'amount:charge'
      //筛选条件-第二步-选择过滤器
      filterShow: false,//1、开关过滤器下拉弹窗
      selectoption: [],//2、下拉弹窗的过滤条件列表（/src/component/assets/selectoption.json）
      filter: {},//3、下拉弹窗过滤条件列表的过滤选中的值  {"value":"gt","label":"大于"}
      //筛选条件-第三步-填写条件值
      columnValue: '',//筛选的条件值
      //筛选条件-结果
      filter_mapper: {},//筛选条件的枚举，用与筛选结果中逻辑的值（如大于、等于）显示
      queryCond: [],//筛选结果的列表
      /**
       [{
       columnName: "project:quotation_type"
       columnValue: "平台发奖服务"
       filter: "eq"
       }]
       */

      selectColumnNameInput: '',//筛选列中的input输入框内容
      selectColoumName: '',

      //预设另存为操作，另存为完成后预设内容回滚
      actionCallback: [],


      //汇总相关
      summaryLoading: false,
      isSummary: 0,//是否进行汇总
      accu_dimension: [],//已选汇总纬度
      summaryObj: [],
      accu_period: '',//选择的时间粒度
      accu_period_maper: [//时间粒度汇总类型枚举
        {
          id: 'date:year',
          type: '年'
        },
        {
          id: 'date:quarter',
          type: '季'
        },
        {
          id: 'date:month',
          type: '月'
        },
        {
          id: 'date:week',
          type: '周'
        },
      ],


      queryData: null,


      pickerOptions: {
        shortcuts: [
          {
            text: '本周',
            onClick(picker) {
              const end = getWeekEndDate()
              const start = getWeekStartDate()
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '上周',
            onClick(picker) {
              const start = getLastWeekStartDate()
              const end = getLastWeekEndDate()
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '本月',
            onClick(picker) {
              const end = getMonthEndDate()
              const start = getMonthStartDate()
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const end = getLastMonthEndDate()
              const start = getLastMonthStartDate()
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '全部选择',
            onClick(picker) {
              picker.$emit('pick', '');
            }
          }
        ]
      },
      //日期选择器
      // shortcuts: [
      //   {
      //     text: '最近一周',
      //     value: () => {
      //       const end = new Date()
      //       const start = new Date()
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      //       return [start, end]
      //     },
      //   },
      //   {
      //     text: '最近一个月',
      //     value: () => {
      //       const end = new Date()
      //       const start = new Date()
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      //       return [start, end]
      //     },
      //   },
      //   {
      //     text: '最近三个月',
      //     value: () => {
      //       const end = new Date()
      //       const start = new Date()
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      //       return [start, end]
      //     },
      //   },
      // ],
      accu_start_end_date: '',
      accu_start_end_date_dynamic: [
        {
          key: 'normal',
          value: '',
          date: ''
        }, {
          key: 'normal',
          value: '',
          date: ''
        }],
      accu_start_end_date_dynamic_init: [
        {
          key: 'normal',
          value: '',
          date: ''
        }, {
          key: 'normal',
          value: '',
          date: ''
        }],

      lastSelectDates: [{
        key: 'normal',
        value: '',
        date: ''
      }, {
        key: 'normal',
        value: '',
        date: ''
      }],
      isShortCut: [false, false],//是否捷径中选择

      defaultColoumsAccu: ['amount:quotation', 'amount:income', 'amount:cost', 'amount:invoice', 'amount:collection', 'amount:purchase', 'amount:apply', 'amount:charge', 'amount:consume'],
      tabShow:true,
      seletcTab: this.isSummary ? '1' : '0',
      navigateTabs: [
        {
          id: '0',
          label: '明细'
        },
        {
          id: '1',
          label: '分类汇总'
        },
      ],
    };
  },
  watch: {
    refreshId(newVal){
      // console.log('refreshId change,refresg table',newVal)
      if(this.isSummary){
        this.$refs.mytable2.refresh()
        this.querySummaryPageData()
      }else{
        this.$refs.mytable.refresh()
        this.queryPagedata()
      }
      this.tabShow = false
      this.$nextTick(()=>{
        this.tabShow = true
      })
    },

    isSummary(newVal) {
      this.seletcTab = newVal + ''
    },

    accu_start_end_date(newVal) {
      let oldVal = this.lastSelectDates
      // console.log('check-----------------\n', newVal[0], oldVal[0].date)
      if (newVal[0] != oldVal[0].date) {
        if (this.isShortCut[0] == true) {
          // console.log('this.isShortCut[0]', this.isShortCut[0])

          this.isShortCut[0] = false
          this.lastSelectDates[0] = {...this.accu_start_end_date_dynamic[0]}
          // console.log("accu_start_end_date/shortCut", this.accu_start_end_date_dynamic)
        } else {
          // console.log("accu_start_end_date/nomal", [...newVal])
          this.accu_start_end_date_dynamic[0] = {key: 'normal', value: newVal[0], date: newVal[0]}
          this.lastSelectDates[0] = {...this.accu_start_end_date_dynamic[0]}
          // console.log('this.lastSelectDates[0]', this.lastSelectDates[0])
        }
      } else if (newVal[1] != oldVal[1].date) {
        if (this.isShortCut[1] == true) {
          // console.log('this.isShortCut[1]', this.isShortCut[1])

          this.isShortCut[1] = false
          this.lastSelectDates[1] = {...this.accu_start_end_date_dynamic[1]}
          // console.log("accu_start_end_date/shortCut", this.accu_start_end_date_dynamic)
        } else {
          // console.log("accu_start_end_date/nomal", [...newVal])
          this.accu_start_end_date_dynamic[1] = {key: 'normal', value: newVal[1], date: newVal[1]}
          this.lastSelectDates[1] = {...this.accu_start_end_date_dynamic[1]}
        }
      } else if (newVal[0] == oldVal[0].date) {
        //日期相同，但是是从动态日期点击到不动态日期
        // console.log('newVal[0]==oldVal[0].date',newVal[0],oldVal[0])

      }


      this.querySummaryPageData()
    },
    accu_period(newVal) {
      // console.log('accu_period(newVal)', newVal)
      // this.querySummaryPageData()
    },


    /**
     * 侧边栏顶部类型tab切换（预设 自定义 常用）
     * @param val
     */
    async btSelect(val) {
      // this.isSummary = 0
      // console.log('侧边栏顶部类型tab切换 - btSelect')
      // this.$refs.mytable.isLoading = true
      if (val === 'pre') {
        if (this.selectPre.length > 0) {
          if (this.itemSelectType === 'pre') {
            // console.log('原选择item为预设，不作操作')
          } else {
            // console.log('原选择item不是预设，显示第一个item')
            this.initDetailData(this.selectPre[0])

            this.initSummaryData(parseSelectionContent(this.selectPre[0].content))
            this.$refs.mytable.filterChange()
            // await this.queryPagedata()//去掉，updateLasttime中有queryPagedata
            //设置点击的更新时间
            await this.updateLasttime()
          }

        } else {
          this.showColoums = []
        }
        // this.$refs.mytable.isLoading = false
      } else if (val === 'addanother') {
        //另存为
        // console.log('btselect/addanother/isSummary', this.isSummary)
        this.$refs.mytable.filterChange()
        // this.$refs.mytable.isLoading = false
        return
      } else if (val === 'custom') {
        if (this.selectCustom.length > 0) {
          if (this.itemSelectType === 'custom') {//如果原来类型就是自定义，不用设置到默认第一个
            // console.log('原选择item为自定义，不作操作')
          } else {//如果原来选择不是自定义，则默认显示第一个item
            // console.log('原选择item不是自定义，显示第一个item')
            this.initDetailData(this.selectCustom[0])

            this.initSummaryData(parseSelectionContent(this.selectCustom[0].content))
            this.$refs.mytable.filterChange()
            //获取数据
            // await this.queryPagedata()//去掉，updateLasttime中有queryPagedata
            //设置点击的更新时间
            await this.updateLasttime()

          }
        } else {
          this.showColoums = []
        }
        // this.$refs.mytable.isLoading = false
      } else {
        // this.$refs.mytable.isLoading = false
        if (this.selectOften.length > 0) {
          this.initDetailData(this.selectOften[0])

          this.initSummaryData(parseSelectionContent(this.selectOften[0].content))
          this.$refs.mytable.filterChange()
          await this.queryPagedata()
        } else {
          this.showColoums = []
        }

      }

    },

    /**
     * 屏幕宽度监听
     * @param val
     */
    screenWidth(val) {
      // console.log(val / 1920)
      if (!this.timer) {
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // console.log(that.screenWidth)
          that.init()
          that.timer = false
        }, 400)
      }
    }
  },
  computed: {
    /**
     * 只有date、number型可以出现在汇总列表中
     * 在column_mapper的基础上，过滤出数值型和date型
     */
    column_summary_mapper() {
      // column_mapper
      let x = {}
      if (!this.column_mapper) return x
      for (let key in this.column_mapper) {
        let value = this.column_mapper[key]
        var type = value.slice(value.lastIndexOf(':') + 1, value.length)

        if (type === 'varchar') {
          x[key] = this.column_mapper[key]
        }
      }
      return x
    },

    /**
     * 汇总页汇总条件
     * @returns {*[]}
     */
    column_summary_array() {
      // column_mapper
      let x = []
      // console.log('this.column_mapper_accu', this.column_mapper_accu)
      if (!this.column_mapper_accu) return x
      for (let key in this.column_mapper_accu) {
        let value = this.column_mapper_accu[key]
        var type = value.slice(value.lastIndexOf(':') + 1, value.length)

        if (type === 'varchar') {
          if (key !== 'project:project_id' && key !== 'project:project_name') {
            x.push({
              value: key,
              label: value,
              checked: false
            })
          }
        } else if (type === 'char') {
          if (key.split(':')[0] === 'date') {
            x.push({
              value: key,
              label: value,
              checked: false
            })
          }
        }


      }
      // console.log('x', x)
      return x
    },

    /**
     * 汇总的字段过滤，只能选择数字型的
     * @returns {{}}
     */
    column_mapper_accu_filter() {
      let temp_column_mapper_accu = {}
      for (let key in this.column_mapper_accu) {
        if (key.split(':')[0] === 'amount') {
          temp_column_mapper_accu[key] = this.column_mapper_accu[key]
        }
      }
      return temp_column_mapper_accu
    },

    column_array_accu_filter() {
      let temp_column_arr_accu = []
      for (let key in this.column_mapper_accu) {
        if (this.showColoumsAccu.indexOf(key) !== -1) {
          if (key.split(':')[0] === 'amount') {
            temp_column_arr_accu.push(key)
          }
        }
      }

      // console.log('更新的showColoumsAccu', this.showColoumsAccu)
      //排序更新
      let sortAccu_columns = []
      // console.log('old this.accu_columns',JSON.stringify( this.accu_columns))
      for (const item of this.showColoumsAccu) {
        if (temp_column_arr_accu.indexOf(item) !== -1) {
          sortAccu_columns.push(item)
        }
      }
      // this.accu_columns = sortAccu_columns

      return sortAccu_columns
    },


    /**
     * 筛选条件-选择列输入框中输入内容后过滤出的列的列表
     * @returns {{}}
     */
    column_mapper_show() {
      let x = {}
      if (!this.column_mapper) return x
      for (let key in this.column_mapper) {
        if (this.column_mapper[key].indexOf(this.columnNameInput) !== -1) {
          x[key] = this.column_mapper[key]
        }
      }
      return x
    },

    select_column_mapper_show() {
      let x = {}
      if (!this.column_mapper) return x
      for (let key in this.column_mapper) {
        if (this.column_mapper[key].indexOf(this.selectColumnNameInput) !== -1) {
          x[key] = this.column_mapper[key]
        }
      }
      // console.log('select_column_mapper_show',x)
      return x
    },

    /**
     * 侧边栏顶部tab
     * @returns {*[]}
     */
    selectPre() {
      let list = this.leftSideSelects.filter((item) => {
        if (item.type === 'pre') {
          return true
        }
        return false
      })
      return list
    },
    selectCustom() {
      // console.log('selectCustom/this.leftSideSelects', this.leftSideSelects)
      let list = this.leftSideSelects.filter((item) => {
        if (item.type === 'custom') {
          return true
        }
        return false
      })
      list = list.reverse()
      // console.log('selectCustom', list)
      return list
    },
    selectOften() {
      // console.log('计算属性/selectOften/this.leftSideSelects', this.leftSideSelects)

      let list = JSON.parse(JSON.stringify(this.leftSideSelects))
      list.sort((item1, item2) => {
        return selectionTimeValue(item2.last_time) - selectionTimeValue(item1.last_time)
      })
      return list
    },

    /**
     * 筛选条件-选择过滤器-根据不同列的类型，显示不同过滤器列表
     * @returns {string}
     */
    selectType() {
      if (this.column_mapper[this.coloumName]) {
        var type = this.column_mapper[this.coloumName].slice(this.column_mapper[this.coloumName].lastIndexOf(':') + 1)
        // console.log(type)
        if (type === "decimal" || type === "int") {
          return 'number'
        } else if (type === 'varchar') {
          var filterType = this.column_mapper[this.coloumName].slice(0, 2)
          if (filterType == '时间') {
            return 'date'
          } else {
            return 'string'
          }
        } else {
          return 'date'
        }
      }
    },
  },
  methods: {
    async unusualShow(project_id){
        let res = await getUnusualList({project_id: project_id})
        let resData = res.data

        if (resData.hasOwnProperty('respCode')) {
          if (resData.respCode == "000000") {
            this.tableColumnCustomConfig['project:project_id'].project_id = project_id
            this.tableColumnCustomConfig['project:project_id'].popoverDatas = resData.respData
          } else {
            this.$message.warning(resData.respMsg)
          }
        } else {
          this.$message.error("数据有误")
        }
    },
    openStartPicker() {
      // console.log('openStartPicker')
      this.$refs.startDatePicker.pickerVisible = true
    },

    openEndPicker() {
      // console.log('openEndPicker')
      this.$refs.endDatePicker.pickerVisible = true
    },

    summaryColumnSelectCancel() {
      this.showColoumsAccuTemp = [...this.showColoumsAccu]
      // console.log(this.$refs.selectColumPop);
      this.$refs.selectColumPop.doClose()
    },
    summaryColumnSelectComfirm() {
      if (this.summaryLoading) {
        this.$message.warning('正在获取汇总列表,请稍后');
        return
      }
      this.coloumNameShow = false
      this.showColoumsAccu = [...this.showColoumsAccuTemp]
      this.$refs.selectColumPop.doClose()
      this.querySummaryPageData()
    },


    initDetailData(item) {
      let content = parseSelectionContent(item.content)
      if (!content.columns) {
        this.showColoums = []
      } else {
        this.showColoums = content.columns
      }
      this.itemSelectType = item.type;
      this.itemSelectChanged = false;//切换后的item一定是未更改的item
      this.itemSelectID = item.itemId;
      this.itemName = item.name
      this.queryCond = content.queryCond || []
      let sortCond = content.sortCond || {}
      this.sortColumnName = sortCond.columnName || ""
      this.sortColumnOrder = sortCond.value || ""
    },
    /**
     * 选择左侧不同item时，初始化汇总数据
     * @param content
     */
    initSummaryData(content) {
      // let content = JSON.parse(item.content)
      content = content || {}

      if (content.accu_start && content.accu_end) {
        this.accu_start_end_date = [content.accu_start, content.accu_end]
      } else {
        this.accu_start_end_date = ''
      }

      this.accu_dimension = content.accu_dimension ? content.accu_dimension : []
      this.isSummary = content.isSummary ? 1 : 0

      if (content.accu_columns) {
        this.accu_columns = content.accu_columns
      } else {
        //初始化
        this.accu_columns = this.column_array_accu_filter.length ? this.column_array_accu_filter : this.defaultColoumsAccu

      }
      this.showColoumsAccu = []
      if (content.accu_period) {
        this.accu_period_maper.forEach((item, idx) => {
          if (item.id === content.accu_period) {
            this.accu_period = idx
          }
        })
      } else {
        this.accu_period = ''
      }

      if (content.accu_start_dynamic == undefined && content.accu_end_dynamic == undefined) {
        content.accu_start = content.accu_start ? content.accu_start : ''
        content.accu_end = content.accu_end ? content.accu_end : ''
        this.accu_start_end_date = [content.accu_start, content.accu_end]

        this.accu_start_end_date_dynamic[0] = {
          key: "normal",
          value: content.accu_start,
          date: content.accu_start
        }
        this.accu_start_end_date_dynamic[1] = {
          key: "normal",
          value: content.accu_end,
          date: content.accu_end
        }


      }
      //如果有动态关键字，则动态获取，覆盖content.accu_start
      else if (content.accu_start_dynamic !== 'normal' && content.accu_end_dynamic == 'normal') {
        let getDynamicDic = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_start_dynamic)))
        content.accu_end = content.accu_end ? content.accu_end : ''
        this.accu_start_end_date = [getDynamicDic.date, content.accu_end]
        this.$nextTick(() => {

          this.accu_start_end_date_dynamic[0] = getDynamicDic
          // this.accu_start_end_date_dynamic[1].date = content.accu_end
          // this.accu_start_end_date_dynamic[1].value = content.accu_end
          this.accu_start_end_date_dynamic[1] = {
            key: "normal",
            value: content.accu_end,
            date: content.accu_end
          }
          // console.log('getDynamicDic.date',getDynamicDic.date)
          // console.log('this.accu_start_end_date_dynamic44--------------', this.accu_start_end_date_dynamic)
        })


      } else if (content.accu_start_dynamic == 'normal' && content.accu_end_dynamic !== 'normal') {
        let getDynamicDic = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_end_dynamic)))
        content.accu_start = content.accu_start ? content.accu_start : ''
        this.accu_start_end_date = [content.accu_start, getDynamicDic.date]
        this.$nextTick(() => {

          this.accu_start_end_date_dynamic[1] = getDynamicDic
          // this.accu_start_end_date_dynamic[0].date = content.accu_start
          // this.accu_start_end_date_dynamic[0].value = content.accu_start
          this.accu_start_end_date_dynamic[0] = {
            key: "normal",
            value: content.accu_start,
            date: content.accu_start
          }
          // console.log('getDynamicDic.date',getDynamicDic.date)
          // console.log('this.accu_start_end_date_dynamic55--------------', this.accu_start_end_date_dynamic)
        })


      } else if (content.accu_start_dynamic !== 'normal' && content.accu_end_dynamic !== 'normal') {
        let getDynamicDicStart = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_start_dynamic)))
        let getDynamicDicEnd = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_end_dynamic)))
        this.accu_start_end_date = [getDynamicDicStart.date, getDynamicDicEnd.date]
        this.$nextTick(() => {

          this.accu_start_end_date_dynamic = [getDynamicDicStart, getDynamicDicEnd]
          // console.log('this.accu_start_end_date_dynamic66--------------', this.accu_start_end_date_dynamic)
        })


      } else {
        content.accu_start = content.accu_start ? content.accu_start : ''
        content.accu_end = content.accu_end ? content.accu_end : ''
        this.accu_start_end_date = [content.accu_start, content.accu_end]


        this.accu_start_end_date_dynamic[0] = {
          key: "normal",
          value: content.accu_start,
          date: content.accu_start
        }
        this.accu_start_end_date_dynamic[1] = {
          key: "normal",
          value: content.accu_end,
          date: content.accu_end
        }
      }

    },
    //-----------------------侧边栏事务---------------
    /**
     * 侧边栏列表点击某一个item
     * 列表 selectOften
     * @param item
     *{
         changed: true
         content: "{\"columns\":[\"project:project_id\",\"project:project_name\",\"project:quotation_type\",\"amount:income\",\"amount:collection\",\"status:project_stage\",\"status:project_status\",\"time:first_quotation_time\",\"term_amount:this_week_income\",\"term_amount:last_week_income\"],\"sortCond\":{\"value\":\"desc\",\"columnName\":\"amount:income\"},\"queryCond\":[{\"filter\":\"gt\",\"columnName\":\"time:first_collection_time\",\"columnValue\":\"2020-07-21\"},{\"filter\":\"gt\",\"columnName\":\"amount:collection\",\"columnValue\":\"10000\"}]}"
         itemId: 327
         last_time: "2021-09-29 11:05:19"
         name: "回款大于10k订单"
         type: "custom"
         userid: "890301843802947584"
     }
     *@param index 点击下标
     */
    async leftAsideItemClick(item, index, changeTabAction = false) {

      // console.log("---------------------侧边栏列表点击start------------------------------")
      // console.log("侧边栏列表点击某一个item-leftAsideItemClick:item", item)
      //点击当前item不算(不包括切换tab的情况)
      if (item.itemId === this.itemSelectID && !changeTabAction) {
        // console.log('点击当前item为同一item，无操作')
        return
      }

      if (this.itemSelectChanged) {
        let isSave = await this.changeLeftSizeIdxTips()

        let lastIdx
        this.leftSideSelects.forEach((lastItem, idx) => {
          if (lastItem.itemId == this.itemSelectID) {
            lastIdx = idx
          }
        })

        // console.log('lastIdx', lastIdx)

        if (isSave == 1) {
          // console.log('保存修改操作')
          if (this.leftSideSelects[lastIdx].type == 'pre') {
            //预设的保存是另存为，需要输入保存名称
            // console.log('另存为操作')
            this.opendialog('另存为')

            //等待另存为操作enter回车后执行
            this.actionCallback.push(() => {
              // console.log('还原旧的内容(回调函数)')
              //还原旧的内容
              this.leftSideSelects[lastIdx] = JSON.parse(JSON.stringify(this.leftSideSelectsOld[lastIdx]))
              let content = JSON.parse(JSON.stringify(this.leftSideSelectsOld[lastIdx])).content
              content = JSON.parse(content)


              // let content = JSON.parse(item.content)
              // if (!content.columns) {
              //   this.showColoums = []
              // } else {
              //   this.showColoums = content.columns
              // }
              // this.itemSelectType = item.type;
              // this.itemSelectChanged = false;//切换后的item一定是未更改的item
              // this.itemSelectID = item.itemId;
              // this.itemName = item.name
              // this.queryCond = content.queryCond
              // this.sortColumnName = content.sortCond.columnName || ""
              // this.sortColumnOrder = content.sortCond.value || ""


              //汇总的回滚操作
              this.accu_start_end_date = [content.accu_start, content.accu_end]
              this.accu_dimension = content.accu_dimension
              this.accu_columns = content.accu_columns
              this.showColoumsAccu = []
              this.isSummary = content.isSummary ? 0 : 1
              this.accu_period_maper.forEach((item, idx) => {
                if (item.id === content.accu_period) {
                  this.accu_period = idx
                }
              })

              this.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(this.accu_start_end_date_dynamic_init))

            })
            return false
          } else {
            await this.saveSelect()
            this.$message.success("已保存修改");
            // console.log('筛选条件更新-this.selectsOld[lastIdx].content')
            this.leftSideSelectsOld[lastIdx].content = this.leftSideSelects[lastIdx].content//筛选条件更新
          }
        }
      else if (isSave == 0) {
          // console.log('放弃修改操作,切换侧边item前的itemSelectID:', this.itemSelectID)
          //还原旧的内容
          this.leftSideSelects[lastIdx] = JSON.parse(JSON.stringify(this.leftSideSelectsOld[lastIdx]))
          let content = JSON.parse(JSON.stringify(this.leftSideSelectsOld[lastIdx])).content
          content = JSON.parse(content)
          // console.log('回滚汇总content', content)
          //汇总的回滚操作
          this.accu_start_end_date = [content.accu_start, content.accu_end]
          this.accu_dimension = content.accu_dimension
          this.accu_columns = content.accu_columns
          this.showColoumsAccu = []
          this.isSummary = content.isSummary ? 0 : 1
          this.accu_period_maper.forEach((item, idx) => {
            if (item.id === content.accu_period) {
              this.accu_period = idx
            }
          })
          this.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(this.accu_start_end_date_dynamic_init))

          this.isSummary = content.isSummary ? 1 : 0

          if (changeTabAction) {
            //如果是切换tab操作，则只需要覆盖当前对象为旧对象
            item = JSON.parse(JSON.stringify(this.leftSideSelects[lastIdx]))
            // item.changed = false
          }
        } else {
          //操作取消了
          return false
        }
      } else {
        // console.log('内容无变动')
      }

      this.pageNumber = 1


      // this.$refs.mytable.isLoading = true

      this.initDetailData(item)

      let content = JSON.parse(item.content)

      this.initSummaryData(content)

      this.isSummary = content.isSummary ? 1 : 0

      if (this.isSummary == 0) {
        this.$refs.mytable.filterChange()
        this.$refs.mytable.refresh()
      } else if (this.isSummary == 1) {
        this.querySummaryPageData()
        this.$refs.mytable2.refresh()
      }

      //更新时间，为了让selectOften等侧边列表更新，然后按照更改时间排序
      // console.log('updateLasttime开始')
      await this.updateLasttime()
      // this.$refs.mytable.isLoading = false
      // console.log("---------------------侧边栏列表点击end------------------------------")
      return true
    },

    /**
     * 侧边栏列表点击其他item，如果当前item有修改弹窗提示
     */
    async changeLeftSizeIdxTips() {
      return new Promise((resolve =>
              this.$confirm('检测到未保存的内容，是否在离开页面前保存修改？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '放弃修改'
              })
                  .then(() => {
                    resolve(1)
                  })
                  .catch((action) => {
                    // console.log('action', action)
                    if (action == 'cancel') {
                      this.$message.info("已放弃修改");
                      resolve(0)
                    } else {
                      this.$message.info("操作已取消");
                      resolve(-1)
                    }

                  })
      ))

    },

    /**
     * 侧边栏tab切换前校验
     */
    async tabSelectInterceptor(type) {
      if (type == this.btSelect) {
        // console.log('同一tab，无操作')
        return
      }
      if (this.itemSelectChanged) {
        //保存操作
        let isChangeSelect = await this.leftAsideItemClick(this.selectOften[0], 0, true)
        // console.log('是否切换tab', isChangeSelect)
        if (isChangeSelect) {
          this.$nextTick(() => {
            this.btSelect = type
          })
        }
      } else {
        this.$nextTick(() => {
          this.btSelect = type
        })
      }

    },

    /**
     * 动态日期关键字获取日期
     */
    getDynamicDate(keyword) {
      let dynamicDateMap = {
        lastWeekStart: {
          value: '上周第一天',
          date: getLastWeekStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        lastMonthStart: {
          value: '上月第一天',
          date: getLastMonthStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        lastQuarterStart: {
          value: '上季第一天',
          date: getLastQuarterStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        lastYearStart: {
          value: '上年第一天',
          date: getLastYearStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },

        weekStart: {
          value: '本周第一天',
          date: getWeekStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        monthStart: {
          value: '本月第一天',
          date: getMonthStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        quarterStart: {
          value: '本季第一天',
          date: getQuarterStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        yearStart: {
          value: '本年第一天',
          date: getYearStartDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },



        lastWeekEnd: {
          value: '上周最后一天',
          date: getLastWeekEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        lastMonthEnd: {
          value: '上月最后一天',
          date: getLastMonthEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        lastQuarterEnd: {
          value: '上季最后一天',
          date: getLastQuarterEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        lastYearEnd: {
          value: '上年最后一天',
          date: getLastYearEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },

        weekEnd: {
          value: '本周最后一天',
          date: getWeekEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        monthEnd: {
          value: '本月最后一天',
          date: getMonthEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        quarterEnd: {
          value: '本季最后一天',
          date: getQuarterEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },
        yearEnd: {
          value: '本年最后一天',
          date: getYearEndDate().format('yyyy-MM-dd')
          // date:'2021-10-01'
        },


      }
      return {
        key: keyword,
        value: dynamicDateMap[keyword].value,
        date: dynamicDateMap[keyword].date,
      }
    },

    /**
     * 获取侧边栏列表（初次加载）
     * @returns {Promise<void>}
     */
    async getSelection() {//获取筛选的列表
      let param = {
        userid: userid
      }
      let res
      try {
        res = await getSelection(param)
      } catch (e) {
        //请求失败时侧边栏和列表都会为空，给出明确提示，避免页面看起来“什么都没有”
        console.error('获取侧边栏搜索条件失败', e)
        this.$message.error('获取搜索条件失败，请检查后端服务是否正常')
        return
      }

      let result = res && res.data ? res.data.result : null
      if (!Array.isArray(result) || result.length === 0) {
        console.warn('未获取到侧边栏搜索条件', res)
        this.leftSideSelects = []
        this.leftSideSelectsOld = []
        this.$message.warning('暂无搜索条件')
        return
      }

      this.leftSideSelects = JSON.parse(JSON.stringify(result))
      this.leftSideSelectsOld = JSON.parse(JSON.stringify(result))

      this.initChanged()

      let list = JSON.parse(JSON.stringify(this.leftSideSelects))
      list.sort((item1, item2) => {
        //不同浏览器时间解析兼容
        return selectionTimeValue(item2.last_time) - selectionTimeValue(item1.last_time)//降序排序
      })
      // console.log('页面初始化，获取侧边列表-getSelection/list', list)
      if (list.length > 0) {
        this.itemSelectType = list[0].type;
        this.itemSelectChanged = false;
        this.itemSelectID = list[0].itemId
        this.itemName = list[0].name
        let content = parseSelectionContent(list[0].content)


        this.queryCond = content.queryCond || []//提取查询内容
        let sortCond = content.sortCond || {}
        this.sortColumnName = sortCond.columnName || ""//提取排序字段名
        this.sortColumnOrder = sortCond.value || ""//提取排序的值desc｜｜asc
        if (!content.columns) {//表头
          this.showColoums = []
        } else {
          this.showColoums = content.columns
        }

        //TODO：初次加载也要加上accu的
        if (content.accu_dimension) {
          this.accu_dimension = content.accu_dimension
        }
        this.accu_columns = content.accu_columns
        // console.log('初次加载，this.accu_columns', this.accu_columns)

        this.accu_period_maper.forEach((item, idx) => {
          if (item.id === content.accu_period) {
            this.accu_period = idx
          }
        })
        this.isSummary = content.isSummary ? 1 : 0


        if (content.accu_start_dynamic == undefined && content.accu_end_dynamic == undefined) {
          content.accu_start = content.accu_start ? content.accu_start : ''
          content.accu_end = content.accu_end ? content.accu_end : ''
          this.accu_start_end_date = [content.accu_start, content.accu_end]


          this.accu_start_end_date_dynamic[0] = {
            key: "normal",
            value: content.accu_start,
            date: content.accu_start
          }
          this.accu_start_end_date_dynamic[1] = {
            key: "normal",
            value: content.accu_end,
            date: content.accu_end
          }

          this.firstQuery()
        }
        //如果有动态关键字，则动态获取，覆盖content.accu_start
        else if (content.accu_start_dynamic !== 'normal' && content.accu_end_dynamic == 'normal') {
          let getDynamicDic = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_start_dynamic)))
          content.accu_end = content.accu_end ? content.accu_end : ''
          this.accu_start_end_date = [getDynamicDic.date, content.accu_end]
          this.$nextTick(() => {

            this.accu_start_end_date_dynamic[0] = getDynamicDic
            this.accu_start_end_date_dynamic[1] = {
              key: "normal",
              value: content.accu_end,
              date: content.accu_end
            }
            // console.log('getDynamicDic.date',getDynamicDic.date)
            // console.log('this.accu_start_end_date_dynamic11--------------', this.accu_start_end_date_dynamic)
            this.firstQuery()
          })


        } else if (content.accu_start_dynamic == 'normal' && content.accu_end_dynamic !== 'normal') {
          let getDynamicDic = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_end_dynamic)))
          content.accu_start = content.accu_start ? content.accu_start : ''
          this.accu_start_end_date = [content.accu_start, getDynamicDic.date]
          this.$nextTick(() => {

            this.accu_start_end_date_dynamic[1] = getDynamicDic
            this.accu_start_end_date_dynamic[0] = {
              key: "normal",
              value: content.accu_start,
              date: content.accu_start
            }
            // console.log('getDynamicDic.date',getDynamicDic.date)
            console.log('this.accu_start_end_date_dynamic22--------------', this.accu_start_end_date_dynamic)
            this.firstQuery()
          })


        } else if (content.accu_start_dynamic !== 'normal' && content.accu_end_dynamic !== 'normal') {
          let getDynamicDicStart = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_start_dynamic)))
          let getDynamicDicEnd = JSON.parse(JSON.stringify(this.getDynamicDate(content.accu_end_dynamic)))
          this.accu_start_end_date = [getDynamicDicStart.date, getDynamicDicEnd.date]
          this.$nextTick(() => {

            this.accu_start_end_date_dynamic = [getDynamicDicStart, getDynamicDicEnd]
            console.log('this.accu_start_end_date_dynamic33--------------', this.accu_start_end_date_dynamic)
            this.firstQuery()
          })


        } else {
          content.accu_start = content.accu_start ? content.accu_start : ''
          content.accu_end = content.accu_end ? content.accu_end : ''
          this.accu_start_end_date = [content.accu_start, content.accu_end]


          this.accu_start_end_date_dynamic[0] = {
            key: "normal",
            value: content.accu_start,
            date: content.accu_start
          }
          this.accu_start_end_date_dynamic[1] = {
            key: "normal",
            value: content.accu_end,
            date: content.accu_end
          }
          this.firstQuery()
        }


      }
    },

    /**
     * 第一次请求数据
     */
    firstQuery() {
      if (this.isSummary == 1) {
        // console.log('!!querySummaryPageData')
        this.queryPagedata()//筛选列需要数据
        this.querySummaryPageData()
      } else if (this.isSummary == 0) {
        //获取表格数据
        this.queryPagedata()
        this.$refs.mytable.filterChange()
      }
    },

    /**
     * 初始化变更判断标志位
     */
    initChanged() {
      this.leftSideSelects.forEach((item) => {
        item.changed = false
      })
    },
    /**
     * 侧边底部保存搜索条件
     * @returns {Promise<void>}
     */
    async saveSelect() {
      this.op = 'update'
      this.itemSelectChanged = false
      await this.changeSelection()
    },


    //------------------侧边栏更多操作事务------------------------
    /**
     * 另存为操作按下enter
     */
    async addAnother() {//另存为一条搜索条件
      console.log('addAnother')
      if (this.anotherName === '') {
        this.$message.warning({
          message: '名字为必填项',
          type: 'warning',
          duration: 1000
        });
        return
      }
      if (this.anotherName.length > 11) {
        this.$message.warning({
          message: '名称不能超过11个字',
          type: 'warning',
          duration: 1000
        });
        return
      }
      if (this.op === 'updateName') {
        //更新搜索名字
        await this.updateName()
      } else {
        //另存为
        await this.changeSelection()
      }
      this.dialogShow = false
      this.anotherName = ""
      console.log('另存为另一条搜索条件')

      if (this.actionCallback.length) {
        // 恢复预设的默认配置
        let reversePreConfig = this.actionCallback.pop()
        reversePreConfig()//恢复预设的默认配置
        this.actionCallback = [] //actionCallback清空
      }
    },

    /**
     * 确认删除本条搜索
     */
    deleteSelect() {
      console.log('删除本条搜索')
      this.dialogShow = false
      this.deleteShow = false
      this.op = 'delete'
      this.changeSelection()
    },
    /**
     * 另存为或修改名称弹窗输入框
     * @param item
     */
    opendialog(item) {
      if (item === "另存为") {
        this.op = 'create'
      } else {
        this.op = "updateName"
      }
      this.dialogShow = false
      let that = this
      this.$nextTick(function () {
        // console.log('that.$refs.inputs',that.$refs.inputs)
        that.$refs.inputs[0].focus()
      })
    },

    /**
     * 输入新搜索条件取消对焦
     */
    inputBlur() {
      console.log('取消了对焦')
      this.op = ''
      this.anotherName = ''
    },


    //--------------------筛选事务------------------------
    /**
     * 隐藏筛选条件弹窗
     */
    filterHiden() {
      console.log('filterHiden')
      this.coloumNameShow = false;
      this.filterShow = false
    },

    /**
     * 筛选条件-选择列-弹出列的列表
     */
    openColoumName() {
      console.log('openColoumName')
      if (this.filterShow) {
        this.filterShow = !this.filterShow
      } else {
      }
      console.log('openColoumName:this.coloumNameShow', this.coloumNameShow)
      this.coloumNameShow = !this.coloumNameShow;
      console.log('openColoumName:this.coloumNameShow:after', this.coloumNameShow)
    },
    /**
     * 筛选条件-选择列-输入框输入内容时，保存弹窗弹出
     */
    coloumNameChange() {
      console.log('coloumNameChange')
      this.coloumNameShow = true
    },
    /**
     * 筛选条件-选择列-选择弹窗列表的某个item
     * @param coloumName 选择列的key
     */
    getColoumName(coloumName) {
      console.log('getColoumName')
      this.filter = {}
      this.coloumName = coloumName;
      this.columnNameInput = this.column_mapper[this.coloumName].slice(0, this.column_mapper[this.coloumName].lastIndexOf(":"))
      this.coloumNameShow = false
    },

    /**
     * 筛选条件-选择过滤器-弹出过滤条件的列表
     */
    openFilter() {
      console.log('openFilter')
      if (this.coloumNameShow) {//如果选择列弹窗弹出了，则关闭弹窗
        this.coloumNameShow = !this.coloumNameShow
      }
      if (this.coloumName === "") {//如果选择列没有选，则弹出选择列列表
        this.openColoumName()
        return
      }

      //打开过滤器列表
      this.filterShow = !this.filterShow
    },
    /**
     * 筛选条件-选择过滤器-选择弹出过滤条件的某个item
     * @param filter 过滤条件的字典
     */
    getFilter(filter) {
      console.log('getFilter:filter', filter)
      this.filter = filter
      this.filterShow = false
    },

    /**
     * 清空筛选条件
     */
    emptySelect() {
      console.log('清空筛选条件')
      this.coloumName = ""
      this.columnNameInput = ""
      this.filter = {}
      this.columnValue = ""
      this.queryCond = []
      this.findSelsectChanged('emptySelect')
      this.queryPagedata()
      if (this.isSummary) {
        this.querySummaryPageData()
      }
    },
    /**
     * 提交筛选条件
     */
    submitSelect() {
      if (this.coloumName === '' || this.filter === '' || this.columnValue === '') {
        this.$message.warning({
          message: '未正确输入数据',
          type: 'warning',
          duration: 1000
        });
        return
      }
      if (this.selectType === 'date') {
        if (!(isNaN(this.columnValue) && !isNaN(Date.parse(this.columnValue))) || this.columnValue.length != 10) {
          this.$message.warning({
            message: '未输入正确时间格式',
            type: 'warning',
            duration: 1000
          });
          return
        }
      }
      let item = {
        filter: this.filter.value,
        columnName: this.coloumName
      }
      console.log('submitSelect:item', item)
      //在列表和不在列表条件需要单独处理
      if (this.filter.value === "in" || this.filter.value === "nin") {
        console.log('------------------')
        let ishave = this.queryCond.some((item) => {
          if (item.columnName === this.coloumName && item.filter === this.filter.value) {
            console.log('在这里asdadada')
            //用中文或因为的逗号作分割
            this.columnValue.split(/[,，]/).forEach((i) => {
              item.columnValue.unshift(i)
            })
            return true
          }
        })
        if (!ishave) {
          console.log('在这里')
          item.columnValue = this.columnValue.split(/[,，]/)
          console.log(item)
          this.queryCond.unshift(item)
        }
        this.findSelsectChanged('submitSelect1')
        this.pageNumber = 1
        this.queryPagedata()
        this.coloumName = ""
        this.columnNameInput = ""
        this.filter = {}
        this.columnValue = ""
        return
      }
      item.columnValue = this.columnValue
      console.log('submitSelect:item:after', item)
      this.queryCond.unshift(item)//当前查询条件插入查询条件列表最前面
      console.log('submitSelect:this.queryCond', this.queryCond)
      this.findSelsectChanged('submitSelect2')
      this.pageNumber = 1
      this.queryPagedata()
      this.coloumName = ""
      this.columnNameInput = ""
      this.filter = {}
      this.columnValue = ""


      if (this.isSummary) {
        this.querySummaryPageData()
      }
    },
    /**
     * 筛选条件结果列表，移除某个筛选结果条件
     * @param e
     */
    removeSelect(e) {
      let num = 0
      this.queryCond.forEach((item, index) => {
        if (JSON.stringify(item) === JSON.stringify(e)) {
          num = index
        }
      })
      this.queryCond.splice(num, 1)
      this.findSelsectChanged('removeSelect')
      this.queryPagedata()
      if (this.isSummary) {
        this.querySummaryPageData()
      }
    },

    /**
     * 列筛选item点击
     * @param item 被点击的列筛选条件
     */
    coloumsChange(item) {
      if (item === "project:project_id" || item === "project:project_name") {
        this.$message.warning({
          message: '此列为必显示列',
          type: 'warning',
          duration: 1000
        });
        return
      }
      //如果当前显示列列表中不存在该点击列时，添加进去
      if (this.showColoums.indexOf(item) === -1) {
        this.showColoums.push(item)
        this.findSelsectChanged('coloumsChange1')
      } else {//否则从当前显示列中移除
        //列数至少为1
        if (this.showColoums.length === 1) {
          this.$message.warning({
            message: '必须有一列数据可视',
            type: 'warning',
            duration: 1000
          });
          return
        }
        //删除从当前列列表中移除item
        this.showColoums.splice(this.showColoums.indexOf(item), 1)
        this.findSelsectChanged('coloumsChange2')
      }
    },

    coloumsChangeAccu(item) {
      console.log('coloumsChangeAccu', item)
      //如果当前显示列列表中不存在该点击列时，添加进去
      if (this.showColoumsAccuTemp.indexOf(item) === -1) {
        this.showColoumsAccuTemp.push(item)
        // this.findSelsectChanged('coloumsChangeAccu1')
      } else {//否则从当前显示列中移除
        //列数至少为1,this.accu_dimension.length为已选汇总字段的长度，不算显示列的,+1是订单数一栏，+1是至少1列数据
        if (this.showColoumsAccuTemp.length <= this.accu_dimension.length + 2) {
          this.$message.warning({
            message: '必须有一列数据可视',
            type: 'warning',
            duration: 1000
          });
          return
        }
        //删除从当前列列表中移除item
        this.showColoumsAccuTemp.splice(this.showColoumsAccuTemp.indexOf(item), 1)
        // this.findSelsectChanged('coloumsChangeAccu2')
      }
    },


    //----------------------数据同步事务----------------------
    /**
     * 更改左侧栏item的名称
     * @returns {Promise<void>}
     */
    async updateName() {
      let param = {
        userid: userid,
        itemId: this.itemSelectID,
        name: this.anotherName
      }
      let {data: {result}} = await updateName(param)
      this.leftSideSelects = result.map((item, index) => {
        item.content = this.leftSideSelects[index].content
        item.changed = this.leftSideSelects[index].changed
        return item
      })
      this.op = ''
      this.queryPagedata()
    },
    /**
     * 更新操作事件
     * @returns {Promise<void>}
     */
    async updateLasttime() {
      console.log('-------更新侧边栏点击item的时间start--------')
      console.log('this.itemSelectID', this.itemSelectID)
      let param = {
        userid: userid,
        itemId: this.itemSelectID,
      }
      let {data: {result}} = await updateLasttime(param)
      this.leftSideSelects = result.map((item, index) => {
        item.content = this.leftSideSelects[index].content
        item.changed = this.leftSideSelects[index].changed
        return item
      })
      await this.queryPagedata()
      console.log('-------更新侧边栏点击item的时间end----------')
    },

    /**
     * 获取订单数据（表格数据）
     * @returns {Promise<void>}this.sortColumnName
     */
    async queryPagedata() {
      let param = {
        userid: userid,
        itemId: this.itemSelectID,
        name: this.itemName,
        queryCond: JSON.parse(JSON.stringify(this.queryCond)),
        sortCond: {
          columnName: this.sortColumnName,
          value: this.sortColumnOrder
        },
        pagiInfo: {
          currentPage: this.op === 'refresh' ? 1 : this.pageNumber,
          pagesize: this.pagesize
        }
      }

      this.detailLoading = true

      try {
        let data = await getProjects(param)
        this.queryData = data.data
        const {data: {column_mapper, totalnums, detail}} = data
        if (column_mapper) {
          delete column_mapper.create_time
          delete column_mapper.id
          delete column_mapper.update_time
        }
        //页面列数初始化
        // console.log('获取列枚举-queryPagedata:column_mapper',column_mapper)
        this.column_mapper = column_mapper || {}
        this.totalnums = totalnums || 0
        this.projectList = detail || []
        if (this.op === 'refresh') {
          this.pageNumber = 1
        }
        this.op = ''

        // this.$nextTick(() => {
        //   this.$refs.eltable.doLayout()
        // })
        if (this.$refs.mytable) {
          this.$refs.mytable.refresh()
        }
      } catch (e) {
        console.error('获取订单列表失败', e)
        this.$message.error('获取订单列表失败，请稍后重试')
      } finally {
        this.detailLoading = false
      }

    },

    /**
     * 条件的改变（点击保存、删除等操作，更新数据接口）
     * @returns {Promise<void>}
     */
    async changeSelection() {
      console.log('条件的改变-changeSelection')
      let saveContent = {
        columns: this.showColoums,
        sortCond: {
          columnName: this.sortColumnName,
          value: this.sortColumnOrder
        },
        queryCond: this.queryCond,
        accu_dimension: this.accu_dimension,
        //TODO:accu_sortCond暂时禁用
        accu_sortCond: {
          columnName: "amount:income",
          value: "desc"
        },
        accu_columns: this.column_array_accu_filter.length ? this.column_array_accu_filter : this.defaultColoumsAccu,
        accu_period: '',
        accu_start: this.accu_start_end_date ? this.accu_start_end_date[0] : '',
        accu_end: this.accu_start_end_date ? this.accu_start_end_date[1] : '',
        isSummary: this.isSummary,
        accu_start_dynamic: this.accu_start_end_date_dynamic[0].key,
        accu_end_dynamic: this.accu_start_end_date_dynamic[1].key
        //为了回滚用的数据
        // showColoumsAccu:this.showColoumsAccu
      }

      // console.log('JSON.stringify(saveContent)', JSON.stringify(saveContent))

      let param = {
        userid: userid,
        itemId: this.itemSelectID,
        name: this.op === 'update' ? this.itemName : this.anotherName,
        op: this.op,
        queryCond: this.queryCond,
        sortCond: {
          columnName: this.sortColumnName,
          value: this.sortColumnOrder
        },
        columns: this.showColoums,

        content: saveContent
      }

      let saveAsCallbackSection = null
      if(this.op=='create'){
        //另存为操作，需要回滚原数据
        this.leftSideSelectsOld.forEach(item => {
          if (this.itemSelectID === item.itemId) {
            saveAsCallbackSection = item
            console.log('找到另存为搜索的原来条件/saveAsCallbackSection',saveAsCallbackSection)
          }
        })
      }



      let {data: {result}} = await changeSelection(param)
      // console.log('result', result)
      this.leftSideSelectsOld = JSON.parse(JSON.stringify(result))
      //保存更新操作
      if (this.op === 'update') {
        this.leftSideSelects = result.map((item, index) => {
          if (this.itemSelectID === item.itemId) {
            return item
          } else {
            return this.leftSideSelects[index]
          }
        })
        //TODO:保存后不获取重新数据
        // this.queryPagedata()
        return
      }
      console.log('op', this.op)
      console.log('op result', result)

      if(saveAsCallbackSection){
        //如果是另存为操作，则还原原来的
        this.leftSideSelects.forEach((item,idx)=>{
          if(saveAsCallbackSection.itemId==item.itemId){
            this.leftSideSelects[idx] = saveAsCallbackSection
          }
        })
      }


      this.leftSideSelects = result.map((item, index) => {
        if (index !== result.length - 1) {
          item.content = this.leftSideSelects[index].content
          item.changed = this.leftSideSelects[index].changed
        } else {
          //默认选择最后一个,作为左边已选对象
          this.itemSelectType = item.type;
          this.itemSelectChanged = item.changed;
          this.itemSelectID = item.itemId
          this.itemName = item.name
          this.queryCond = JSON.parse(item.content).queryCond
          this.sortColumnName = JSON.parse(item.content).sortCond.columnName || ""
          this.sortColumnOrder = JSON.parse(item.content).sortCond.value || ""

          if (!JSON.parse(item.content).columns) {
            this.showColoums = []
          } else {
            this.showColoums = JSON.parse(item.content).columns
          }

          let content = JSON.parse(item.content)
          if (content.accu_dimension) {
            this.accu_dimension = content.accu_dimension
          }

          this.isSummary = content.isSummary ? content.isSummary : 0

          if (this.op === 'create') {
            this.btSelect = 'addanother'
          }
          // this.queryPagedata()
        }
        if (!item.changed) {
          item.changed = false
        }
        return item
      })
      //this.leftSideSelectsOld重新赋值
      this.leftSideSelectsOld = JSON.parse(JSON.stringify(this.leftSideSelects))



      this.op = ''

        //删除或者更新完之后，模拟顶部tab点击，使列表更新
        let lastBtSelect = this.btSelect
        this.btSelect = ''
        this.$nextTick(()=>{
          this.btSelect = lastBtSelect
        })




    },


    keySort(target) {
      const newObj = {}
      Object.keys(target).sort().map(key => newObj[key] = target[key])
      return newObj
    },

    cleanTrim(str) {
      return str.split(" ").join("");
    },

    /**
     * 字典判断是否重复
     * @param oldItem
     * @param newItem
     * @returns {boolean}
     */
    checkIsSame(oldItem, newItem) {
      let oldContent = JSON.parse(oldItem)
      let newContent = JSON.parse(newItem)
      console.log('old -> accu_start_dynamic/end', oldContent.accu_start_dynamic, oldContent.accu_end_dynamic)
      console.log('new -> accu_start_dynamic/end', newContent.accu_start_dynamic, newContent.accu_end_dynamic)
      if (JSON.stringify(oldContent.columns) !== JSON.stringify(newContent.columns)) {
        console.log('columns not diff')
        return false
      }

      if (JSON.stringify(this.keySort(oldContent.sortCond)) !== JSON.stringify(this.keySort(newContent.sortCond))) {
        console.log('sortCond not diff')
        return false
      }

      if (JSON.stringify(this.keySort(oldContent.queryCond)) !== JSON.stringify(this.keySort(newContent.queryCond))) {
        console.log('queryCond not diff')
        return false
      }


      if (oldContent.accu_dimension) {

        if (this.cleanTrim(JSON.stringify(this.keySort(oldContent.accu_dimension))) !== this.cleanTrim(JSON.stringify(this.keySort(newContent.accu_dimension)))) {
          console.log('accu_dimension not diff')
          return false
        }
      }

      if (this.isSummary) {
        if (oldContent.accu_sortCond) {
          if (JSON.stringify(this.keySort(oldContent.accu_sortCond)) !== JSON.stringify(this.keySort(newContent.accu_sortCond))) {
            console.log('accu_sortCond not diff')
            return false
          }
        }

        if (oldContent.accu_columns) {
          if (JSON.stringify(oldContent.accu_columns) !== JSON.stringify(newContent.accu_columns)) {
            console.log('accu_columns not diff')
            return false
          }
        }

      }

      //原来没有，然后新增，显示差异
      if (!oldContent.isSummary && newContent.isSummary == true) {
        return false
      }

      if (!oldContent.accu_dimension && newContent.accu_dimension && newContent.accu_dimension.length > 0) {
        return false
      }
//原来没有，然后新增，显示差异
      if (newContent['accu_period'] !== undefined && oldContent['accu_period'] == undefined && newContent['accu_period'] !== '') {
        return false
      }
      //原来没有，然后新增，显示差异
      if (newContent['accu_start'] !== undefined && oldContent['accu_start'] == undefined && newContent['accu_start'] !== '') {
        return false
      }
      if (newContent['accu_end'] !== undefined && oldContent['accu_end'] == undefined && newContent['accu_end'] !== '') {
        return false
      }

      //原来没有，然后新增，显示差异
      if (newContent['accu_start_dynamic'] !== undefined && oldContent['accu_start_dynamic'] == undefined && newContent['accu_start_dynamic'] != 'normal') {
        console.log('accu_start_dynamic' + ' not diff', newContent['accu_start_dynamic'], oldContent['accu_start_dynamic'])
        return false
      }
      if (newContent['accu_end_dynamic'] !== undefined && oldContent['accu_end_dynamic'] == undefined && newContent['accu_end_dynamic'] != 'normal') {
        console.log('accu_end_dynamic' + ' not diff', newContent['accu_start_dynamic'], oldContent['accu_start_dynamic'])
        console.log('newContent[\'accu_end_dynamic\'] !== \'normal\'', newContent['accu_end_dynamic'] != 'normal')
        return false
      }

      for (const key in newContent) {
        if (typeof newContent[key] !== 'object') {
          if (oldContent[key] !== undefined) {
            if (newContent[key] != oldContent[key]) {
              console.log(key + ' not diff')
              if(key==='accu_start'){
                if (newContent['accu_start_dynamic'] !== undefined && newContent['accu_start_dynamic'] != 'normal') {
                  console.log('动态的accu_start_dynamic，不校验accu_start')
                  continue
                }
              }
              if(key==='accu_end'){
                if (newContent['accu_end_dynamic'] !== undefined && newContent['accu_end_dynamic'] != 'normal') {
                  console.log('动态的accu_end_dynamic，不校验accu_end')
                  continue
                }
              }
              return false
            }
          }

        }

      }

      return true
    },

    /**
     * 判断条件差异（有差异则显示已更改图标）
     */
    findSelsectChanged(fromFunction) {
      console.log('筛选条件更新后，更新侧边栏内部数据-findSelsectChanged,formFunction', fromFunction)
      this.leftSideSelects.some((item, index) => {
        if (item.itemId === this.itemSelectID) {
          let content = {
            columns: this.showColoums,
            sortCond: this.sortColumnName ? {
              value: this.sortColumnOrder,
              columnName: this.sortColumnName
            } : {
              value: "",
              columnName: ""
            },
            queryCond: this.queryCond,

            //汇总相关
            accu_dimension: this.accu_dimension,
            accu_sortCond: {
              columnName: "amount:income",
              value: "desc"
            },
            accu_columns: this.column_array_accu_filter.length ? this.column_array_accu_filter : this.defaultColoumsAccu,
            accu_period: '',
            accu_start: this.accu_start_end_date ? this.accu_start_end_date[0] : '',
            accu_end: this.accu_start_end_date ? this.accu_start_end_date[1] : '',
            isSummary: this.isSummary,
            accu_start_dynamic: this.accu_start_end_date_dynamic[0].key,
            accu_end_dynamic: this.accu_start_end_date_dynamic[1].key
          }
          console.log('before find different', this.accu_start_end_date_dynamic[0].key)
          item.content = JSON.stringify(content)

          // if (item.content !== JSON.stringify(JSON.parse(this.leftSideSelectsOld[index].content))) {
          // console.log('content',content)
          // console.log('JSON.parse(this.leftSideSelectsOld[index].content)',JSON.parse(this.leftSideSelectsOld[index].content))
          // console.log(JSON.stringify(keySort(a)) === JSON.stringify(keySort(b)))
          // if(this.cmp(content,JSON.parse(this.leftSideSelectsOld[index].content))){
          let res = this.checkIsSame(this.leftSideSelectsOld[index].content, item.content)

          if (!res) {
            console.log('----------筛选条件变化了end----------')
            console.log('old', this.leftSideSelectsOld[index].content)
            console.log('new', item.content)
            console.log('----------筛选条件变化了start----------')
            // console.log('item.changed设置为true')
            item.changed = true
          } else {
            // console.log('筛选条件无变化了')
            // console.log('item.changed设置为false')
            item.changed = false
          }
          this.itemSelectChanged = item.changed
          return true
        }
      })
    },

    async accuDimensionUpdate(accu_dimension) {
      this.accu_dimension = accu_dimension


      if (!this.isSummary) return
      // this.$nextTick(() => {
      // this.$refs.mytable2.isLoading = true
      // this.summaryLoading = true
      // })

      await this.querySummaryPageData()
    },

    /**
     * 重排列showColoumsAccu
     */

    reSortAccuColomn(accuColumnDic) {
      let newColumn = []
      // //年月日放最前头
      // for (const key in accuColumnDic) {
      //   let type = key.split(':')[0]
      //   if (type.indexOf('date') !== -1) {
      //     newColumn.push(key)
      //   }
      // }
      //汇总字段放前头
      for (const item of this.accu_dimension) {
        newColumn.push(item)
      }
      //再到数量
      newColumn.push('count:project_count')

      this.fixedListAccu = [...newColumn]
      //最后就是其他
      for (const key in accuColumnDic) {
        if (newColumn.indexOf(key) === -1) {
          newColumn.push(key)
        }
      }
      // console.log('newColumn', newColumn)
      return newColumn
    },

    /**
     * 将汇总返回的列表处理
     * 总计放最前面
     * 小计加名字
     * @param detail
     */
    summaryDetailFormat(detail) {
      if (!detail || !detail.length) return []
      let first = detail.splice(detail.length - 1, 1)[0];
      let firstColum = this.showColoumsAccu[0]
      // console.log('summaryDetailFormat/accu_dimension', this.accu_dimension)
      // console.log('this.showColoumsAccu',this.showColoumsAccu)
      // console.log('first',first)
      first[firstColum] = '总计'
      detail.unshift(first);
      let fixColumCount = this.accu_dimension.length

      for (let i = 0; i < fixColumCount; i++) {
        let lastEmptyIdx = 0
        detail.forEach((item, idx) => {
          // console.log('item',item[this.accu_dimension[i]])
          let fixColumValue = item[this.accu_dimension[i]]
          if (!fixColumValue && idx > 0) {
            if (idx - lastEmptyIdx == 1) {
              // console.log('i-lastEmptyIdx==1')
              lastEmptyIdx = idx
              return
            }

            // console.log('1111')
            item[this.accu_dimension[i]] = '小计'
            lastEmptyIdx = idx


          }
        })
      }
      // console.log('detail!!',detail)


      return detail
    },

    /**
     * 获取汇总列表数据
     */
    async querySummaryPageData() {
      // console.log('querySummaryPageData')
      if (!this.isSummary) return
      // this.$refs.mytable2.isLoading = true
      // console.log('getAccu/param-before')
      let param = {
        queryCond: JSON.parse(JSON.stringify(this.queryCond)),
        sortCond: {
          columnName: this.sortColumnName,
          value: this.sortColumnOrder
        },
        columns: this.showColoums,
        accu_dimension: this.accu_dimension,
        accu_sortCond: {
          columnName: "amount:income",
          value: "desc"
        },

        //this.accu_columns初次加载的
        //TODO:默认选择的汇总字段要加上预估采购成本聚合
        accu_columns: this.column_array_accu_filter.length ? this.column_array_accu_filter : this.accu_columns ? this.accu_columns : this.defaultColoumsAccu,
        accu_period: '',
        accu_start: this.accu_start_end_date ? this.accu_start_end_date[0] : '',
        accu_end: this.accu_start_end_date ? this.accu_start_end_date[1] : ''
      }

      // console.log('getAccu/param', param)
      this.summaryLoading = true
      // setTimeout(()=>{
      //   this.summaryLoading = true
      // },1000)
      let data = await getAccu(param)
      // console.log('getAccu后端返回数据', data.data)
      // this.queryData = data.data
      const {data: {column_mapper, totalnums, detail}} = data
      // console.log("detail!!!",[...detail])
      delete column_mapper.create_time
      delete column_mapper.id
      delete column_mapper.update_time
      //页面列数初始化
      // console.log('获取列枚举-queryPagedata:column_mapper',column_mapper)
      this.column_mapper_accu = []
      this.column_mapper_accu = column_mapper
      // console.log('this.column_mapper_accu',this.column_mapper_accu)
      this.totalnumsAccu = totalnums
      this.accu_columns = param.accu_columns
      //TODO：保存表头列表
      this.showColoumsAccu = []
      let showColoumsAccu = this.reSortAccuColomn(detail[0])
      // console.log('1showColoumsAccu',showColoumsAccu)
      showColoumsAccu = showColoumsAccu.filter(item => item !== 'project:project_set')
      // console.log('2showColoumsAccu', showColoumsAccu)

      //排序
      let tempCoAccu = []
      for (let i = 0; i < this.accu_columns.length; i++) {
        let findidx = showColoumsAccu.indexOf(this.accu_columns[i])
        if (findidx !== -1) {
          tempCoAccu.push(showColoumsAccu[findidx])
          showColoumsAccu.splice(findidx, 1)
        }
      }
      showColoumsAccu.push(...tempCoAccu)
      // console.log('after', showColoumsAccu)
      this.showColoumsAccu = showColoumsAccu
      this.showColoumsAccuTemp = [...this.showColoumsAccu]

      let format_detail = this.summaryDetailFormat(detail)
      this.projectListAccu = Object.freeze(format_detail)


      // accu_columns

      // this.accu_columns = param.accu_columns

      if (this.op === 'refresh') {
        this.pageNumberAccu = 1
      }
      this.op = ''

      // this.$nextTick(() => {
      //   this.$refs.eltable.doLayout()
      // })
      this.$refs.mytable2.refresh()
      // this.$refs.mytable2.isLoading = false
      this.summaryLoading = false

      this.findSelsectChanged('querySummaryPageData')
    },


    //----------------------表格操作------------------
    beforeLeave(e) {
      // console.log("beforeLeave", e)
      // if(e==="1"){//点击汇总
      //   console.log('1111111')
      //   if (!this.projectList.length&&) {
      //     this.$message.warning('明细列表为空，无法进行汇总')
      //     return false
      //   }
      // }
    },

    /**
     * 汇总操作tab点击
     */
    summaryAction(isSummary) {
      // console.log('summaryAction')
      if (this.isSummary == isSummary) {
        // console.log('已在当前页面，无需请求')
        return false
      }
      if (isSummary) {
        // console.log('there action')
        if (!this.projectList.length) {
          this.$message.warning('明细列表为空，无法进行汇总')
          this.$nextTick(() => {
            this.seletcTab = '0'
          })
          return false
        }
        this.isSummary = isSummary
        // console.log('点击汇总')

        // if(this.accu_dimension.length){
        this.querySummaryPageData()
        // }
      } else {
        this.isSummary = isSummary
        // console.log('点击列表')
        this.$refs.mytable.refresh()
        this.queryPagedata()
      }

      this.findSelsectChanged('summaryAction')
    },


    /**
     * 子组件中列拖拽排序回调
     * @param showColoums 更新后的显示列数组
     */
    columnDropUpdate(showColoums) {
      // console.log('columnDropUpdate', showColoums)
      this.showColoums = showColoums
      //查看是否有差异
      this.findSelsectChanged('columnDropUpdate')
    },
    columnDropUpdateAccu(showColoums) {
      // console.log('old this.showColoumsAccu',JSON.stringify(this.showColoumsAccu))
      this.showColoumsAccu = showColoums
      // this.updateColumnAccuPost()
      // console.log('new this.showColoumsAccu',JSON.stringify(this.showColoumsAccu))
      //查看是否有差异
      this.findSelsectChanged('columnDropUpdateAccu')
    },

    /**
     * 列表拖动排序后，更新请求的汇总列顺序
     */
    // updateColumnAccuPost() {
    //   let sortAccu_columns = []
    //   // console.log('old this.accu_columns', JSON.stringify(this.accu_columns))
    //   for (const item of this.showColoumsAccu) {
    //     if (this.accu_columns.indexOf(item) !== -1) {
    //       sortAccu_columns.push(item)
    //     }
    //   }
    //   this.accu_columns = sortAccu_columns
    //   console.log('new this.accu_columns', JSON.stringify(this.accu_columns))
    //
    // },
    /**
     * 设置页面页数
     * @param pagesize 设置一页页数
     */
    setPagesize(pagesize) {//设置pagesize
      this.pagesize = pagesize
      this.pageNumber = 1
      this.queryPagedata()
    },
    /**
     * 页面刷新
     */
    async refresh() {
      // console.log('刷新')
      // let loadingInstance = this.$loading.service({fullscreen: true, text: '正在刷新'});
      if (this.isSummary) {
        await this.querySummaryPageData()
      } else {
        this.op = 'refresh'
        await this.queryPagedata()
      }

      // loadingInstance.close();
    },

    /**
     * 改变当前页数
     * @param e
     */
    currentChange(e) {
      this.pageNumber = e;
      this.queryPagedata()
    },
    /**
     * 表格根据某列排序改变
     * @param e
     */
    sortChange(e) {
      // console.log('-------排序start------')

      // console.log('排序改变-sortChange')
      if (e.order === null) {
        this.sortColumnName = ""
        this.sortColumnOrder = ""
      } else {
        this.sortColumnName = e.prop
        if (e.order === 'ascending') {
          this.sortColumnOrder = 'asc'
        } else {
          this.sortColumnOrder = 'desc'
        }
      }
      //排序规则更新后，重新回去表格数据
      this.queryPagedata()
      //然后判断表格筛选规则是否变化
      if (this.isSummary == 0) {
        //汇总不存在排序
        this.findSelsectChanged('sortChange')
      }

      // console.log('-------排序end------')
    },
    /**
     * 表格导出excel
     */
    exportExcel() {
      if (this.isSummary) {
        this.exportAccu()
      } else {
        this.export()
      }

    },
    async export() {
      let param = {
        userid: userid,
        itemId: this.itemSelectID,
        op: "export",
        name: this.itemName,
        queryCond: JSON.parse(JSON.stringify(this.queryCond)),
        sortCond: {
          columnName: this.sortColumnName,
          value: this.sortColumnOrder
        },
        columns: this.showColoums,
        pagiInfo: {
          "currentPage": this.pageNumber,
          "pagesize": this.pagesize
        }
      }
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportExcel(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        const fileName = this.itemName + '-' + Y + M + D + H + m + s + ".xlsx"
        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    },

    async exportAccu() {
      let param = {
        userid: userid,
        itemId: this.itemSelectID,
        op: "export",
        name: this.itemName,
        queryCond: JSON.parse(JSON.stringify(this.queryCond)),
        sortCond: {
          columnName: this.sortColumnName,
          value: this.sortColumnOrder
        },
        columns: this.showColoums,
        pagiInfo: {
          "currentPage": this.pageNumber,
          "pagesize": this.pagesize
        },

        //汇总信息
        accu_dimension: this.accu_dimension,
        accu_sortCond: {
          columnName: "amount:income",
          value: "desc"
        },
        accu_columns: this.column_array_accu_filter.length ? this.column_array_accu_filter : this.defaultColoumsAccu,
        accu_period: '',
        accu_start: this.accu_start_end_date ? this.accu_start_end_date[0] : '',
        accu_end: this.accu_start_end_date ? this.accu_start_end_date[1] : '',
      }
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出...'});
      try {
        let {data} = await exportExcelAccu(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        const fileName = this.itemName + '-汇总-' + Y + M + D + H + m + s + ".xlsx"
        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();
        this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
      }
    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick(e) {
      // console.log(e)
      // console.log('rowClick', e['project:project_name'])
      // this.$store.commit("setProjectId", e["project:project_id"]);
      // this.$store.commit("setProjectInfo", {
      //   projectId: e["project:project_id"],
      //   projectName: e["project:project_name"],
      //   accu: 0
      // })
      window.open('http://dao.szltech.com/dao/#/businessAssociation/order/orderDetail?id=' + e["project:project_id"], '_blank')
      // 改为在Home.vue中加入对this.$store.projectInfo的watch
      // this.$parent.$parent.$parent.$parent.handleTabsEdit(e["project:project_name"], 'add', e['project:project_name'] + '-' + e["project:project_id"]);
    },

    rowClickAccu(e) {
      // return
      // console.log('rowClickAccu', e)
      let projects_str = e['project:project_set']
      this.$store.commit("setProjectId", e["project:project_set"]);
      let find_project_name = ""
      for (let key in e) {
        let type = key.split(':')[0]
        // console.log('type', type)
        if (type != 'amount' && type != 'count' && type != 'project') {
          if (e[key]) {
            find_project_name += e[key]
          }
        }
      }

      if (projects_str.split(',').length > 100) {
        this.$message.warning('订单数量超过100条，暂时无法显示详情')
        return
      }

      // console.log('find_project_name', find_project_name)

      this.$store.commit("setProjectInfo", {
        projectId: e["project:project_set"],
        projectName: find_project_name,
        accu: 1
      })


    },


  },
  created() {
    window.vm = this
    // if (process.env.NODE_ENV == "development") {
    //   //调试工具改数据用
    //   window.vm = this
    // }
    let that = this
    this.pickerOptionsStart = {
      //禁用今天往后的日期
      // disabledDate(time) {
      //   return time.getTime() > Date.now();
      // },
      shortcuts: [{
        text: '上周第一天',
        onClick(picker) {
          //如果点击前后日期相同，不会触发日期的update函数
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastWeekStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastWeekStart',
            value: '上周一',
            date: getLastWeekStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }


          that.findSelsectChanged('shortCut')
          //+new Date().format('yyyy-mm-dd')
          picker.$emit('pick', getLastWeekStartDate());
        }
      }, {
        text: '上月第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastMonthStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastMonthStart',
            value: '上月第一天',
            date: getLastMonthStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          that.findSelsectChanged('shortCut')
          picker.$emit('pick', getLastMonthStartDate());
        }
      }, {
        text: '上季第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastQuarterStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastQuarterStart',
            value: '上季第一天',
            date: getLastQuarterStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          that.findSelsectChanged('shortCut')
          picker.$emit('pick', getLastQuarterStartDate());
        }
      }, {
        text: '上年第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastYearStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastYearStart',
            value: '上年第一天',
            date: getLastYearStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          that.findSelsectChanged('shortCut')
          picker.$emit('pick', getLastYearStartDate());
        }
      }
      ,{
        text: '本周第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getWeekStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'weekStart',
            value: '本周第一天',
            date: getWeekStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          that.findSelsectChanged('shortCut')
          picker.$emit('pick', getWeekStartDate());
        }
      }, {
        text: '本月第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getMonthStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'monthStart',
            value: '本月第一天',
            date: getMonthStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          that.findSelsectChanged('shortCut')
          picker.$emit('pick', getMonthStartDate());
        }
      }, {
        text: '本季第一天',
        onClick(picker) {
          // console.log('本季初 click')
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getQuarterStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'quarterStart',
            value: '本季第一天',
            date: getQuarterStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          that.findSelsectChanged('shortCut')
          picker.$emit('pick', getQuarterStartDate());
        }
      }, {
        text: '本年第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getYearStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'yearStart',
            value: '本年第一天',
            date: getYearStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          that.findSelsectChanged('shortCut')
          picker.$emit('pick', getYearStartDate());
        }
      }
        , {
          text: '2018-01-01',
          onClick(picker) {
            that.isShortCut[0] = false
            that.accu_start_end_date_dynamic[0] = {key: 'normal', value: '', date: ''}
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[0] == false) {
              that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
            }

            that.findSelsectChanged('shortCut')
            picker.$emit('pick', '');
          }
        }
      ]
    }

    this.pickerOptionsEnd = {
      //禁用第一个日期选择过的日期前面所有日期
      disabledDate(time) {
        return time.getTime() < new Date(that.accu_start_end_date[0])
      },
      shortcuts: [
        {
          text: '上周最后一天',
          onClick(picker) {
            //如果点击前后日期相同，不会触发日期的update函数
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastWeekEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastWeekEnd',
              value: '上周最后一天',
              date: getLastWeekEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }


            that.findSelsectChanged('shortCutLast')
            //+new Date().format('yyyy-mm-dd')
            picker.$emit('pick', getLastWeekEndDate());
          }
        },
         {
          text: '上月最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastMonthEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastMonthEnd',
              value: '上月最后一天',
              date: getLastMonthEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getLastMonthEndDate());
          }
        }, {
          text: '上季最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastQuarterEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastQuarterEnd',
              value: '上季最后一天',
              date: getLastQuarterEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getLastQuarterEndDate());
          }
        }, {
          text: '上年最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastYearEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastYearEnd',
              value: '上年最后一天',
              date: getLastYearEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getLastYearEndDate());
          }
        },
        {
          text: '本周最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getWeekEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'weekEnd',
              value: '本周最后一天',
              date: getWeekEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getWeekEndDate());
          }
        },
        {
          text: '本月最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getMonthEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'monthEnd',
              value: '本月最后一天',
              date: getMonthEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getMonthEndDate());
          }
        },
        {
          text: '本季最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getQuarterEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'quarterEnd',
              value: '本季最后一天',
              date: getQuarterEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getQuarterEndDate());
          }
        },
        {
          text: '本年最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getYearEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'yearEnd',
              value: '本年最后一天',
              date: getYearEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getYearEndDate());
          }
        }, {
        text: '今天',
        onClick(picker) {
          that.isShortCut[1] = false
          that.accu_start_end_date_dynamic[1] = {key: 'normal', value: '', date: ''}
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[1] == false) {
            that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
          }

          that.findSelsectChanged('shortCutLast')
          picker.$emit('pick', '');
        }
      }]
    }


  },
  mounted() {
    this.getSelection()
    this.selectoption = selectoption.selectoption
    this.filter_mapper = selectoption.filter_mapper
    // document.getElementsByTagName('body')[0].style.zoom = document.body.clientWidth / 1920
    // document.getElementsByTagName('body')[0].style.transform = "scale("+(document.body.clientWidth / 1920)+")"
    // document.getElementsByTagName('body')[0].style.transformOrigin = 0
  },

  activated() {
    // console.log('被keep-alive 缓存的组件激活时调用')
  },


};
</script>

<style lang='scss'>

.prevent-hover {
  pointer-events: none;
}

.el-date-editor {
  //background-color: green;
}

.summarySelect {
  //el-select样式
  .el-input__inner {
    height: 36px;
  }

  //设置右侧按钮居中
  .el-input__suffix {
    top: -2px;
  }

}

.summaryNotSeletItem {
  //没有输入时红色
  //::v-deep(.el-input__inner) {
  //  border-color: #FF4242;
  //  &::placeholder {
  //    color: #FF4242;
  //    font-size: 14px;
  //    font-family: PingFang SC;
  //    line-height: 14px;
  //    font-weight: 400;
  //  }
  //}
  //
  ////箭头红色
  //::v-deep(.el-select__caret.el-input__icon.el-icon-arrow-up){
  //  color: #FF4242;
  //}
}


.cellhover {
  background: red;
}

.typeString {
  text-align: center;
  // width: 98px;
  min-width: 98px;
  line-height: 20px;
}

.typeNumber {
  // background:red;
  line-height: 20px;
  font-size: 14px;
  min-width: 90px;
  // max-width: 120px;
  width: 55%;
  // margin: 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;

}

.deep {
  .el-input__inner {
    width: 360px !important;
    border-radius: 30px !important;
    font-size: 16px;
    padding-left: 68px;
  }
}

.popitem {
  //background: red;
}

.imgbox {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  text-align: center;

  /* 工具栏图标：源图是 30×31 位图，统一按 22px 显示。
   * 显式 background-size 既收小了图标，也去掉了原来溢出的 1px 平铺。
   * 尺寸只在这里定义，下面各图标只负责自己的 background-image。 */
  .refresh,
  .coloums,
  .coloumSelect,
  .select,
  .export,
  .fullScreen {
    width: 22px;
    height: 22px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  &:hover {
    cursor: pointer;
  }

  .refresh {
    background-image: url("../assets/img/refresh.png");
    position: relative;

    &:hover::before {
      content: '刷新';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 40px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../assets/img/refresh_active.png");
    }
  }

  .coloums {
    background-image: url("../assets/img/coloums.png");
    position: relative;

    &:hover::before {
      content: '页面行数';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 50px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../assets/img/coloums_active.png");
    }
  }

  .coloumSelect {
    background-image: url("../assets/img/coloumSelect.png");
    position: relative;

    &:hover::before {
      content: '筛选列';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 50px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../assets/img/coloumSelect_active.png");
    }
  }

  .select {
    background-image: url("../assets/img/select.png");
    position: relative;

    &:hover::before {
      content: '筛选条件';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 50px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../assets/img/select_active.png");
    }
  }

  .export {
    background-image: url("../assets/img/export.png");
    position: relative;

    &:hover::before {
      content: '导出';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 40px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../assets/img/export_active.png");
    }
  }

  .fullScreen {
    background-image: url("../assets/img/fullScreen.png");
    // &:hover{
    //   background-image: url("../assets/img/fullScreen_active.png");
    // }
  }
}

.btn-list {
  // margin: -12px;
  width: 110px;
  // background: red;
  .btn-item {
    // height:32px;
    width: 100%;
    line-height: 32px;
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: #5A5E66;

    &:first-of-type {
      // background: red;
      margin-top: 10px;
    }

    &:last-of-type {
      // background: red;
      margin-bottom: 10px;
    }

    &:hover {
      cursor: pointer;
      font-weight: 600;
      color: #2783EF;
      background: #F6F8FB;
    }
  }

  .delete-item {
    &:hover {
      font-weight: 600;
      color: red;
    }
  }
}

.coloums-list {
  width: 360px;
  // height:495px;
  box-shadow: 0px 0px 12px 0px rgba(143, 159, 182, 0.2);

  .el-input__inner {
    width: 320px;
    height: 36px;
    background: #F5F8FF;
    border-radius: 2px;
    border: none;
    border-left: 3px solid #E2EAF7;
    font-size: 14px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
  }

  .el-input__suffix {
    margin-right: 20px;
  }

  .items-select {
    height: 46px;
    padding-left: 20px;

    .myselect {
      &:hover {
        cursor: pointer;
      }

      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px 0 12px;
      height: 36px;
      width: 320px;
      background: #F5F8FF;
      border-left: 3px solid #E2EAF7;
      color: rgb(202, 196, 214);
      box-sizing: border-box;

      img {
        height: 5px;
        width: 8px;
      }
    }

    .myoption {
      position: relative;
      top: 10px;
      z-index: 200;
      width: 320px;
      max-height: 300px;
      overflow-y: auto;
      background: rgb(255, 255, 255);
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 10%);
      border-radius: 0 0 2px 2px;
      padding: 6px 0;

      ul {
        // background-color: red;
        li {
          height: 34px;
          line-height: 34px;
          padding: 0 20px;

          &:hover {
            background: rgb(245, 247, 250);
          }
        }
      }
    }
  }

  .btn-select {
    width: 320px;
    margin: 10px 20px;
    display: flex;
    justify-content: space-between;
  }

  .coloums-title {
    height: 54px;
    line-height: 60px;
    text-align: center;
    font-size: 16px;
    font-family: SourceHanSansSC-Medium, SourceHanSansSC;
    font-weight: 500;
    color: #586A84;
  }

  .result_title {
    padding-top: 4px;
    text-align: center;
    font-size: 16px;
    font-family: SourceHanSansSC-Medium, SourceHanSansSC;
    font-weight: 500;
    color: #586A84;

    .result {
      margin-top: 4px;
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #586A84;
    }
  }

  .select_list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 20px;
    width: 299px;
    padding-left: 9px;
    padding-right: 12px;
    background: #F5F8FF;
    border-radius: 2px;
    border-left: 3px solid #E2EAF7;
    height: 36px;

  }

  .items {
    font-size: 14px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: #586A84;
    height: 430px;
    overflow-y: auto;

    .item {
      height: 36px;
      line-height: 36px;
      text-align: center;

      &:hover {
        cursor: pointer;
        background: #F5F8FF;
        opacity: 0.9;
        font-family: SourceHanSansSC-Medium, SourceHanSansSC;
        font-weight: 500;
        color: #429FFF;
      }
    }

    .selected {
      background: #F5F8FF;
      opacity: 0.9;
      font-family: SourceHanSansSC-Medium, SourceHanSansSC;
      font-weight: 500;
      color: #429FFF;
    }

    .item-coloums {
      height: 36px;
      line-height: 36px;
      padding-left: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
      }

      &:hover {
        cursor: pointer;
        background: #F5F8FF;
        opacity: 0.9;
        font-family: SourceHanSansSC-Medium, SourceHanSansSC;
        font-weight: 500;
        color: #429FFF;
      }
    }
  }
}

.coloums-width {
  width: 300px;
}

.container {
  width: 100%;
  height: 100%;
  // background: red;
  overflow: hidden;
  margin: auto;
  // background: red;
  .sel-head {
    margin-top: 20px;
    margin-left: 15px;
    margin-bottom: 20px;


    .my-btn {

      background: #E4E9F4;
      border-radius: 4px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 257px;
      height: 36px;

      &-item {
        width: 81px;
        height: 32px;
        font-size: 14px;
        font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        font-weight: 400;
        color: #3F464E;
        text-align: center;
        line-height: 32px;
        cursor: default;

        &:hover {
          cursor: pointer;
        }
      }

      &-select {
        background: #FFFFFF;
        border-radius: 2px;
        color: #328EFF;

        &:hover {
          cursor: pointer;
        }
      }
    }

  }

  .sel-head2 {
    margin-top: 20px;
    margin-left: 15px;
    margin-bottom: 20px;

    .my-btn {
      background: #E4E9F4;
      border-radius: 4px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 36px;
      padding: 0 2px;

      &-item {
        padding: 0 27px;
        height: 32px;
        font-size: 14px;
        font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        font-weight: 400;
        color: #3F464E;
        text-align: center;
        line-height: 32px;
        cursor: default;
      }

      &-select {
        background: #FFFFFF;
        border-radius: 2px;
        color: #328EFF;
      }
    }

  }

  .addSelect {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 228px;
    height: 40px;
    padding: 0;
    background: #2273D2;
    border: 1px solid #2273D2;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(34, 115, 210, 0.24);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease;

    .saveIcon {
      margin-right: 6px;
      font-size: 16px;
    }

    &:hover,
    &:focus {
      background: #1E68C0;
      border-color: #1E68C0;
      color: #FFFFFF;
      box-shadow: 0 4px 12px rgba(34, 115, 210, 0.3);
    }

    &:active {
      background: #1A5CAB;
      border-color: #1A5CAB;
    }

    /* 未修改筛选条件时与既有禁用态一致：浅灰底 + 灰字，不再使用位图 */
    &.is-disabled,
    &.is-disabled:hover,
    &.is-disabled:focus {
      background: #E4E9F4;
      border-color: #E4E9F4;
      color: #A5AEC1;
      box-shadow: none;
      cursor: not-allowed;
    }
  }

  .box-bottom {
    //background: red;
    position: absolute;
    bottom: 0;
    left: 30px;
    width: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
    // background: #F6F8FB;
    border-top: 1px solid #E4E9F4;
  }

  .sel-content {
    position: relative;
    height: calc(100% - 121.5px - 76px);

    ::-webkit-scrollbar {
      width: 6px;
      height: 1px;
      background-color: #F5F5F5;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    ::-webkit-scrollbar-track {
      /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
      border-radius: 3px;
      /* background-color: #F5F5F5; */
    }

    /*定义滑块 内阴影+圆角*/
    ::-webkit-scrollbar-thumb {
      border-radius: 3px;
      /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
      background: rgba(165, 174, 193, 0.7);
      height: 30px;
    }

    .box-card {
      width: 100%;
      height: 100%;

      ul {
        height: 100% !important;
        overflow-y: auto;

        li {
          position: relative;
          width: 272px;
          font-size: 16px;
          font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #3F464E;
          border-bottom: 1px solid rgba(213, 215, 223, .5);
          // &:last-of-type{
          //   border: none;
          // }
          cursor: default;

          &:hover {
            cursor: pointer;
            background: #EBEFF7;
          }

          .text {
            .el-input .el-input__count .el-input__count-inner {
              background: none;
            }

            .el-input__inner {
              height: 50px;
              width: 272px;
              background: #EBEFF7;
              border: none;
              // border-left:1px solid rgba(57, 148, 241, .5);
              padding-left: 4px;
              margin-left: -30px;
              padding-left: 30px;
              font-size: 16px;
              font-family: SourceHanSansSC-Regular, SourceHanSansSC;
              font-weight: 400;
              border-radius: 0;
              // color: #3994F1;
            }

            input::-webkit-input-placeholder {
              font-size: 16px;
              font-family: SourceHanSansSC-Regular, SourceHanSansSC;
              font-weight: 400;
              color: rgba(57, 148, 241, .4);
            }

            display: flex;
            align-items: center;
            padding-left: 30px;
            height: 50px;
            line-height: 50px;

            .dot {
              width: 10px;
              height: 10px;
              margin-right: 6px;
            }
          }

          .btn {
            position: absolute;
            right: 30px;
            top: 19px;
          }

        }

        .li-active {
          background-color: #429FFF;
          color: #FFFFFF;

          &:hover {
            background-color: #429FFF;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}

.el-date-editor .el-range__close-icon {
  //日历去除清楚按钮
  width: 0px;
}

.hoverCls:hover {
  cursor: pointer;
}

.date_style {
  margin-left: -150px;
  width: 150px;
  z-index: -1;
}

.summaryTabs{
  //.el-tabs__active-bar.is-top{
  //  width:150px !important;
  //}
}

/* ===== 新版入口 CTA =====
 * 位置未改动：仍相对 .container（position:relative）绝对定位，
 * top 由 60px 调整为 56px，仅为在高度由 24px 变为 32px 后保持视觉中心不变。
 */
.new-version-link {
  position: absolute;
  top: 56px;
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 14px;
  border-radius: 16px;
  background: linear-gradient(90deg, #2783EF 0%, #58A8FF 100%);
  box-shadow: 0 4px 12px rgba(39, 131, 239, .3);
  color: #FFFFFF;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: transform .2s ease, box-shadow .2s ease;

  &:hover {
    color: #FFFFFF;
    text-decoration: none;
    box-shadow: 0 6px 16px rgba(39, 131, 239, .42);

    .new-version-link__arrow {
      transform: translateX(3px);
    }
  }

  &:active {
    box-shadow: 0 2px 6px rgba(39, 131, 239, .3);
  }

  // “NEW” 角标：白底蓝字，与渐变底形成强对比
  .new-version-link__badge {
    display: inline-flex;
    align-items: center;
    height: 18px;
    padding: 0 6px;
    margin-right: 8px;
    border-radius: 9px;
    background: #FFFFFF;
    color: #2783EF;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .5px;
    line-height: 1;
  }

  // 指向性箭头：hover 时右移，暗示“可以过去”
  .new-version-link__arrow {
    margin-left: 6px;
    font-size: 14px;
    transition: transform .2s ease;
  }
}

</style>
